webpackJsonp([1],{

/***/ "0fkY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "52Ql":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bh4A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BpBR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EUPG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GT0P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HgIx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3395e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("0fkY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e4cd6ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("52Ql")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3190bf5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("QkI9")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-3190bf5a"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-772adcfe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"},on:{"click":_vm.toggleContents}},[_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("WN8W")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-772adcfe"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56463f7a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.link))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("Bh4A")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-56463f7a"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a441386","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("oPvi")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c0d9e23","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("i9d8")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd022a4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("uDJ7")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: []
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36923708","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("eJtY")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b6e97a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("Pg37")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48277a17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("EUPG")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5139845f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1))]),_vm._v(" "),_c('p',{staticClass:"contents-item__text--title"},[_vm._v(_vm._s(_vm.page[0].title))]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("HgIx")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage', 'showContents']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14d3008a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("U2l4")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e5c2ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("V6ic")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1f72b0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-745923cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("pXbK")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22bcc19e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("Zf2O")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10484467","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("S4/L")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-10484467"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c172f84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n                            c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n                            c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n                            h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n                            c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n                            M123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n                            c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n                            c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n                            c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n                            c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n                            c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n                            c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n                            C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n                            c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n                            c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n                            c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n                            L154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("GT0P")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94cb9f4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("BpBR")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2b54d16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{attrs:{"to":_vm.nextPageURI,"classes":"navigation-link--next"}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("tGyY")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Escrime XII - Issue 120",
  "shortTitle": "",
  "description": "",
  "width": 1173,
  "height": 880,
  "currentLanguage": "ES",
  "languages": [{
    code: "EN",
    text: "English",
    href: "https://escrime-xxi.fie.org/120/en/"
  }, {
    code: "FR",
    text: "French",
    href: "https://escrime-xxi.fie.org/120/fr/"
  }, {
    code: "ES",
    text: "Spanish",
    href: "https://escrime-xxi.fie.org/120/es/"
  }],
  "basePath": "/120/es",
  // "basePath": "",
  "companyLogo": "logo.png",
  "publishURL": "https://escrime-xxi.fie.org/120/es/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": false,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "downloadPath": '/120/es/static/_content/escrime-120-es.pdf',
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": true,
    "editionsEnabled": false,
    "mobileSwitch": true,
    "guideEnabled": false
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 1-title\" style=\"top:84px;left:52px;\" src=\"/120/es/static/_content/1-title-1.png\">\n        <img class=\"abs halfScale 1-title\" style=\"top:210px;left:52px;\" src=\"/120/es/static/_content/1-title-2.png\">\n        <img class=\"abs halfScale 1-title\" style=\"top:1px;left:290px;\" src=\"/120/es/static/_content/1-numerals-1.png\">\n        <img class=\"abs halfScale 1-title\" style=\"top:84px;left:824px;\" src=\"/120/es/static/_content/1-ed-1.png\">\n        <!-- <img class=\"abs halfScale 1-title\" style=\"top:84px;left:957px;\" src=\"/120/es/static/_content/logo.png\"> -->\n        <img class=\"abs halfScale 1-title\" style=\"top:360px;left:50px;\" src=\"/120/es/static/_content/1-sub-1.png\">\n        <img class=\"abs halfScale 1-title\" style=\"top:503px;left:53px;\" src=\"/120/es/static/_content/1-sub-2.png\">\n        <img class=\"abs halfScale 1-title\" style=\"top:569px;left:54px;\" src=\"/120/es/static/_content/1-sub-3.png\">\n        <img id=\"1-arrow\" class=\"halfScale pointer\" style=\"top:756px;right:-70px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/1-arrow.png\">\n      ",
    "mobileHtml": "\n        <img src=\"/120/es/static/_content/1-mobile-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim\n            .staggerFromTo(cOf(\"1-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)\n            .fromTo(idOf(\"1-arrow\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n      \n        function onPageLeave() {\n          pg1Anim.stop();\n        }\n      ",
    "searchText": "N˚120 REVISTA DIGITAL  FÉDÉRATION INTERNATIONALE D’ESCRIME  Campeonatos del Mundo Juniors y Cadetes Copa del Mundo Gran Premio  Utilice el teclado o arrastre el dedo por la pantalla para desplazarse a la izquierda y a la derecha por toda la revista"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 2-title\" style=\"top:84px;left:64px;\" src=\"/120/es/static/_content/2-title-1.png\">\n        <img class=\"abs halfScale pointer howto-desktop\" style=\"top:96px;left:822px;\" onclick=\"switchPopHowto(true)\"\n          src=\"/120/es/static/_content/2-btn-1.png\">\n        <img class=\"abs halfScale pointer howto-ipad\" style=\"top:96px;left:976px;opacity:0\" onclick=\"switchPopHowto(false)\"\n          src=\"/120/es/static/_content/2-ipad-btn.png\">\n        <img class=\"abs halfScale 2-img howto-desktop\" style=\"top:202px;left:64px;\" src=\"/120/es/static/_content/2-img-1.png\">\n        <img class=\"abs halfScale 2-img howto-ipad\" style=\"top:191px;left:64px; opacity:0\" src=\"/120/es/static/_content/2-ipad.png\">\n        <img class=\"abs halfScaleC 2-text\" style=\"top:605px;left:20px;\" src=\"/120/es/static/_content/2-text-1.png\">\n        <img class=\"abs halfScaleC 2-text\" style=\"top:599px;left:236px;\" src=\"/120/es/static/_content/2-text-2.png\">\n        <img class=\"abs halfScaleC 2-text\" style=\"top:597px;left:538px;\" src=\"/120/es/static/_content/2-text-3.png\">\n        <img class=\"abs halfScaleC 2-text\" style=\"top:597px;left:799px;\" src=\"/120/es/static/_content/2-text-4.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg2Anim = new TimelineMax();\n          pg2Anim\n            .staggerFromTo(cOf(\"2-text\"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.3, 1)\n        }\n\n        function switchPopHowto(bool){\n          if(bool){\n            TweenMax.to(cOf(\"howto-ipad\"), 0.5, {opacity:0, onComplete:function(){\n              cOf(\"howto-ipad\")[0].style.opacity = 0;\n              cOf(\"howto-ipad\")[1].style.display = \"none\";\n            }});\n            cOf(\"howto-desktop\")[0].style.opacity = 1;\n            cOf(\"howto-desktop\")[1].style.display = \"block\";\n            TweenMax.to(cOf(\"howto-desktop\"), 0.5, {opacity:1});\n          }else{\n            cOf(\"howto-ipad\")[0].style.opacity = 1;\n            cOf(\"howto-ipad\")[1].style.display = \"block\";\n            TweenMax.to(cOf(\"howto-ipad\"), 0.5, {opacity:1});\n            TweenMax.to(cOf(\"howto-desktop\"), 0.5, {opacity:0, onComplete:function(){\n              cOf(\"howto-desktop\")[0].style.opacity = 0;\n              cOf(\"howto-desktop\")[1].style.display = \"none\";\n            }});\n          }\n        }\n\n        function onPageLeave() {\n          pg2Anim.stop();\n          resetNumbers(\"2-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "INSTRUC CIONES DE USO  Haga clic para cambiar la vista  INSTRUCCIONES DE USO  IPAD  ESCRITORIO  Escrime XXI  La revista de esgrima utiliza la última tecnología digital. Presentamos algunas características de uso para disfrutar de la publicación.  DEP ORTE  GRAN PREMIO DE ESPADA MASCULINA Y FEMENINA EN BUDAPEST BUDAPEST, HUNGRÍA 4–6 MARZO 2022  EXPLORAR Utilice las flechas del teclado para desplazarse horizontalmente por la revista  Navegación  Para ver la revista, utilice las flechas del teclado para desplazarse a la izquierda y a la derecha por toda la publicación.  EXPLORADOR DE INTERNET Para obtener los mejores resultados, recomendamos el uso de Safari o Google Chrome.  EXPLORAR  r… Zonas interactivas en el interio  1 2 3 ELEMENTOS EMERGENTES  BOTÓN DE REPRODUCCIÓN  REDES SOCIALES  NÚMEROS  Pulse para mostrar u ocultar retazos de información.  En esta revista encontrará vídeos fantásticos. Pulse este botón para disfrutar de ellos.  Pulse los iconos de las redes sociales que encontrará por toda la revista.  Pulse los botones para mostrar más contenidos apasionantes.  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.absolutefencinggear.com/\" target=\"_blank\" class=\"contentLinkNone\" style=\"    top: 720px; left: 430px; width: 710px; height: 60px;\"></a>\n      ",
    "mobileHtml": "\n        <a href=\"https://www.absolutefencinggear.com/\" target=\"_blank\">\n          <img src=\"/120/es/static/_content/3-mobile-1.jpg\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 4-title\" style=\"top:47px;left:63px;\" src=\"/120/es/static/_content/4-title-1.png\">\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC abs halfpulse animatedpulse\" style=\"top: 47px; left:644px;\" src=\"/120/es/static/_content/fb-navy.png\">\n        </a>\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC abs halfpulse animatedpulse\" style=\"top: 86px; left:644px;\" src=\"/120/es/static/_content/tw-navy.png\">\n        </a>\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n        <img id=\"4-next\" class=\"halfScale pointer\" style=\"top:719px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-pad-sky.png\">\n\n          <img class=\"cont-item cont-item-1-btn\" style=\"top:251px;left:439px;opacity:0;transform:scale(0.9); transform-origin:top left;\"\n              src=\"/120/es/static/_content/4-popup-1-1.png\">\n          <img class=\"cont-item cont-item-2-btn halfScale\" style=\"top:259px;left:440px;opacity:0\"\n            src=\"/120/es/static/_content/4-popup-2-1.png\">\n          <img class=\"cont-item cont-item-3-btn halfScale\" style=\"top:259px;left:440px;opacity:0\"\n            src=\"/120/es/static/_content/4-popup-2-2.png\">\n          <img class=\"cont-item cont-item-4-btn halfScale\" style=\"top:204px;left:440px;opacity:0\"\n            src=\"/120/es/static/_content/4-popup-3-1.png\">\n          <img class=\"cont-item cont-item-5-btn halfScale\" style=\"top:269px;left:440px;opacity:0\"\n            src=\"/120/es/static/_content/4-popup-4-1.png\">\n          <img class=\"cont-item cont-item-6-btn halfScale\" style=\"top:204px;left:440px;opacity:0\"\n            src=\"/120/es/static/_content/4-popup-5-1.png\">\n          <img class=\"cont-item cont-item-7-btn halfScale\" style=\"top:251px;left:440px;opacity:0\"\n            src=\"/120/es/static/_content/4-popup-6-1.png\">\n          \n          <div class=\"addContentLink\" onclick=\"contentsBub(1);\" style=\"top: 275px; left: 65px; width: 377px; height: 50px;\"></div>\n          <div class=\"addContentLink\" onclick=\"contentsBub(2);\" style=\"top: 345px; left: 65px; width: 377px; height: 50px;\"></div>\n          <div class=\"contentLinkNone 2-click\" onclick=\"contentsBub(2);\"\n          style=\"top: 715px; left: 496px; width: 169px; height: 54px;display:none\"></div>\n          <div class=\"contentLinkNone 3-click\" onclick=\"contentsBub(2);\"\n          style=\"top: 715px; left: 496px; width: 169px; height: 54px;display:none\"></div>\n          <div class=\"contentLinkNone 2-click\" onclick=\"contentsBub(3);\"\n            style=\"top: 715px; left: 688px; width: 169px; height: 54px;display:none\"></div>\n          <div class=\"contentLinkNone 3-click\" onclick=\"contentsBub(3);\"\n            style=\"top: 715px; left: 688px; width: 169px; height: 54px;display:none\"></div>\n          <div class=\"addContentLink\" onclick=\"contentsBub(4);\" style=\"top: 415px; left: 65px; width: 377px; height: 50px;\"></div>\n          <div class=\"addContentLink\" onclick=\"contentsBub(5);\" style=\"top: 486px; left: 65px; width: 377px; height: 50px;\"></div>\n          <div class=\"addContentLink\" onclick=\"contentsBub(6);\" style=\"top: 556px; left: 65px; width: 377px; height: 50px;\"></div>\n          <div class=\"addContentLink\" onclick=\"contentsBub(7);\" style=\"top: 626px; left: 65px; width: 377px; height: 50px;\"></div>\n          \n          <div class=\"contentLink cont-item-1-link\" onclick=\"Publish.goToPage(6)\"\n            style=\"top: 273px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n\n          <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(8)\"\n            style=\"top: 275px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(10)\"\n            style=\"top: 345px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(14)\"\n            style=\"top: 415px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(17)\"\n            style=\"top: 486px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(20)\"\n            style=\"top: 556px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(22)\"\n            style=\"top: 626px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-3-link\" onclick=\"Publish.goToPage(25)\"\n            style=\"top: 275px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-3-link\" onclick=\"Publish.goToPage(27)\"\n            style=\"top: 345px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-3-link\" onclick=\"Publish.goToPage(31)\"\n            style=\"top: 415px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-3-link\" onclick=\"Publish.goToPage(33)\"\n            style=\"top: 486px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-3-link\" onclick=\"Publish.goToPage(35)\"\n            style=\"top: 556px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-3-link\" onclick=\"Publish.goToPage(39)\"\n            style=\"top: 626px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          \n          <div class=\"contentLink cont-item-4-link\" onclick=\"Publish.goToPage(45)\"\n            style=\"top: 415px; left: 442px; width: 590px; height: 50px;display:none;\"></div>\n          \n          <div class=\"contentLink cont-item-5-link\"\n            onclick=\"Publish.goToPage(47)\"\n            style=\"top: 486px; left: 442px; width: 636px; height: 50px;display:none;\"></div>\n          \n          <div class=\"contentLink cont-item-6-link\" onclick=\"Publish.goToPage(51);setTimeout(function(){showOverlay('51-popups-1'), 1000})\"\n            style=\"top: 556px; left: 442px; width: 636px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-6-link\" onclick=\"Publish.goToPage(51);setTimeout(function(){showOverlay('51-popups-2'), 1000})\"\n            style=\"top: 626px; left: 442px; width: 636px; height: 50px;display:none;\"></div>\n          \n          <div class=\"contentLink cont-item-7-link\" onclick=\"Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-1', '53-cta-1'), 1000})\"\n            style=\"top: 275px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-7-link\" onclick=\"Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-2', '53-cta-2'), 1000})\"\n            style=\"top: 345px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-7-link\" onclick=\"Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-3', '53-cta-3'), 1000})\"\n            style=\"top: 415px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-7-link\" onclick=\"Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-4', '53-cta-4'), 1000})\"\n            style=\"top: 486px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-7-link\" onclick=\"Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-5', '53-cta-5'), 1000})\"\n            style=\"top: 556px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n          <div class=\"contentLink cont-item-7-link\" onclick=\"Publish.goToPage(53);setTimeout(function(){pg53Toggle('53-6', '53-cta-6'), 1000})\"\n            style=\"top: 626px; left: 442px; width: 594px; height: 50px;display:none;\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n          pg4Anim\n            .fromTo(cOf(\"4-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(idOf(\"4-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n\n        function contentsBub(index){\n          console.log(index)\n          for(var i=0; i <= 9; i++){\n            if(i == index){\n              [].slice.call(cOf(\"cont-item-\"+i+\"-link\")).reduce(function(p,c){\n                c.style.display = \"\";\n              },0);\n              [].slice.call(cOf(i+\"-click\")).reduce(function(p,c){\n                c.style.display = \"\";\n              },0);\n              TweenMax.to(cOf(\"cont-item-\"+i+\"-btn\"), 0, {opacity:1, onComplete:function(){\n                \n                cOf(\"cont-item-\"+index+\"-link\")[0].style.display = \"\"\n                if(cOf(\"cont-item-\"+index+\"-link\")[1]){\n                  cOf(\"cont-item-\"+index+\"-link\")[1].style.display = \"\" \n                }\n              }});\n            }else{\n              [].slice.call(cOf(\"cont-item-\"+i+\"-link\")).reduce(function(p,c){\n                  c.style.display = \"none\";\n                },0);\n              [].slice.call(cOf(i+\"-click\")).reduce(function(p,c){\n                  c.style.display = \"none\";\n                },0);\n              TweenMax.to(cOf(\"cont-item-\"+i+\"-btn\"), 0, {opacity:0});\n            }\n          }\n        }\n\n        function onPageLeave() {\n          pg4Anim.stop();\n          resetNumbers(\"4-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "ÍNDICE  EN ESTE NÚMERO  Le damos la bienvenida a la última edición de Escrime XXI, que llega repleta de las mejores imágenes, vídeos y artículos del mundo de la esgrima, y presenta una imagen totalmente fresca y renovada.  WWW.FIE.ORG  EDITORIAL  DEPORTE  Pulse los botones para revelar el contenido  NOTICIAS DE LA FIE N˚120  NOTICIAS DE CONFEDERACIÓN Y FEDERACIÓN  REVISTA DIGITAL  FÉDÉRATION INTERNATIONALE D’ESCRIME  NOTICIAS DEL MUNDO  Campeonatos del Mundo Juniors y Cadetes Copa del Mundo  NECROLÓGICAS  Gran Premio  Utilice el teclado o arrastre el dedo por la pantalla para desplazarse a la izquierda y a la derecha por toda la revista  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n        <a href=\"mailto:info@fie.ch\">\n          <div class=\"contentLink\" style=\"bottom: 162px; right: 526px; width: 124px; height: 21px;\"></div>\n        </a>\n        <a href=\"http://www.touchline.com\" target=\"_blank\">\n          <div class=\"contentLink\" style=\"bottom: 160px; right: 236px; width: 234px; height: 21px;\"></div>\n        </a>\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLink\" style=\"bottom: 140px; right: 568px; width: 82px; height: 21px;\"></div>\n        </a>\n\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:785px;left:41px\"\n            src=\"/120/es/static/_content/tw-white.png\">\n        </a>\n\n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:785px;left:94px\"\n            src=\"/120/es/static/_content/fb-white.png\">\n        </a>\n\n        <a href=\"https://www.youtube.com/user/FIEvideo\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:785px;left:147px\"\n            src=\"/120/es/static/_content/yt-white.png\">\n        </a>\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n\n        <img id=\"5-next\" class=\"halfScale pointer\" style=\"top:653px;right:-80px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-pad-sky.png\">\n      ",
    "mobileHtml": "\n        <p><strong>Presidente interino:</strong><br>Emmanuel Katsiadakis (M.H.) (GRE)\n          <br><strong>Secretaria tesorera:</strong><br>Ferial Nadira Salhi (ALG)\n        </p>\n        <p><strong>Vicepresidentes:</strong><br>Ana Pascu (M.H.) (ROU)<br>Donald Anthony (USA)<br>Yuki Ota (JPN)</p>\n        <p><strong>Miembros:</strong><br>Erika Aze (LAT)<br>Jacek Bierkowski (POL)<br>Ana Irene Delgado Guerra (PAN)<br>Velichka Hristeva (BUL)<br>Isabelle Lamour (FRA)<br>Novak Perovic (RSA)<br>Oleg Peskov (KAZ)<br>Giorgio Scarso (ITA)<br>Bence Szabo (HUN)<br>Pascal Tesch (LUX)<br>Aldo Montano Presidente de la Comisi\xF3n de Atletas de la FIE (ITA)</p>\n        <p><strong>Presidente de la Confederaci\xF3n Africana de Esgrima:</strong><br>Mbagnick Ndiaye (SEN) <br><strong>Presidente de la Confederaci\xF3n Panamericana de Esgrima:</strong><br>Vitaly Logvin (MEX) <br><strong>Presidente de la Confederaci\xF3n Asi\xE1tica de Esgrima:</strong><br>HH. Engr. Sheikh Salem Sultan S. Al Qasimi (UAE)<br><strong>Presidente de la Confederaci\xF3n Europea de Esgrima:</strong><br>Stanislav Pozdnyakov (RUS)\n          <br><strong>Presidente de la Confederaci\xF3n Oce\xE1nica de Esgrima:</strong><br>Helen Smith (M.H.) (AUS)\n        </p>\n        <h2 id=\"fie-head-office\">OFICINA CENTRAL DE LA FIE</h2>\n        <p><strong>Directora general</strong><br>Nathalie Rodriguez M.-H. (FRA)\n        </p>\n        <h2 id=\"administration\">Administraci\xF3n</h2>\n        <p><strong>Directora administrativa:</strong><br>Elena Murdaca (ITA)<br><strong>Gestora de contabilidad:</strong><br>Sandra Baroni (SUI) <br><strong>Asistente de direcci\xF3n:</strong><br>Gabrielle Meylan (BRA)<br><strong>Asistente administrativa:</strong><br>Ylenia Murdaca (ITA)</p>\n        <h2 id=\"sport\">Deporte</h2>\n        <p><strong>Director t\xE9cnico y deportivo:</strong><br>Evgeny Tsoukhlo (RUS)<br><strong>Manager de la tecnolog\xEDa y de la administraci\xF3n del deporte:</strong><br>Natalia Bodrova (RUS)<br><strong>Jefe de operaciones:</strong><br>Elena Huot (RUS)</p>\n        <h2 id=\"communication-marketing-tv\">Comunicaci\xF3n, Marketing, TV</h2>\n        <p><strong>Jefe del gabinete del presidente:</strong><br>Nina Lalovic (SRB)<br><strong>Manager digital y de comunicaciones:</strong><br>Maria Ntanou (GRE)<br><strong>Jefe de producci\xF3n TV de la FIE:</strong><br>Barna Heder (HUN) <br><strong>Asistente de producci\xF3n TV de la FIE:</strong><br>Svetlana Krasnokoutskaya (RUS)<br><strong>Encargado de prensa:</strong><br>Serge Timacheff (USA)<br><strong>Fot\xF3grafo:</strong><br>Augusto Bizzi (ITA)</p>\n        <h2 id=\"design\">Dise\xF1o</h2>\n        <p>Touchline (www.touchline.com)</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg5Anim = new TimelineMax();\n          pg5Anim\n            .fromTo(idOf(\"5-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg5Anim.stop();\n          resetNumbers(\"5-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "C OMITÉ E JECUTIVO DE L A FIE  OFICINA CENTRAL DE LA FIE  Presidente interino: Emmanuel Katsiadakis (M.H.) (GRE) Secretaria tesorera: Ferial Nadira Salhi (ALG)  Directora general Nathalie Rodriguez M.-H. (FRA)  Vicepresidentes: Ana Pascu (M.H.) (ROU) Donald Anthony (USA) Yuki Ota (JPN) Miembros:  Administración  Directora administrativa: Elena Murdaca (ITA) Gestora de contabilidad: Sandra Baroni (SUI) Asistente de dirección: Gabrielle Meylan (BRA) Asistente administrativa: Ylenia Murdaca (ITA)  Erika Aze (LAT) Jacek Bierkowski (POL) Ana Irene Delgado Guerra (PAN) Velichka Hristeva (BUL) Isabelle Lamour (FRA) Novak Perovic (RSA) Oleg Peskov (KAZ) Giorgio Scarso (ITA) Bence Szabo (HUN) Pascal Tesch (LUX)  Deporte  Director técnico y deportivo: Evgeny Tsoukhlo (RUS)  Manager de la tecnología y de la administración del deporte: Natalia Bodrova (RUS) Jefe de operaciones: Elena Huot (RUS) Comunicación, Marketing, TV  Aldo Montano Presidente de la Comisión de Atletas de la FIE (ITA)  Jefe del gabinete del presidente:  Presidente de la Confederación Africana de Esgrima: Mbagnick Ndiaye (SEN) Presidente de la Confederación Panamericana de Esgrima: Vitaly Logvin (MEX) Presidente de la Confederación Asiática de Esgrima: HH. Engr. Sheikh Salem Sultan S. Al Qasimi (UAE) Presidente de la Confederación Europea de Esgrima: Stanislav Pozdnyakov (RUS) Presidente de la Confederación Oceánica de Esgrima: Helen Smith (M.H.) (AUS)  Official Publication of the FIE International Fencing Federation Head-office of the FIE Maison du Sport International Avenue de Rhodanie 54 CH-1007 Lausanne  Tel.: +41 21 320 31 15 Fax: +41 21 320 31 16 e-mail: info@fie.ch www.fie.org  Nina Lalovic (SRB)  Manager digital y de comunicaciones: Maria Ntanou (GRE)  Jefe de producción TV de la FIE: Barna Heder (HUN)  Asistente de producción TV de la FIE: Svetlana Krasnokoutskaya (RUS) Encargado de prensa: Serge Timacheff (USA) Fotógrafo: Augusto Bizzi (ITA) Diseño Touchline (www.touchline.com)  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "\n        <img id=\"6-img\" class=\"halfScale 6-text-1 6-text\" style=\"top:145px;left:367px\"\n          src=\"/120/es/static/_content/6-img-1.png\">\n        <img id=\"6-title\" class=\"halfScale 6-title 6-text-1 6-text\" style=\"top:629px;left:329px\"\n          src=\"/120/es/static/_content/6-title-1.png\">\n        \n        <img id=\"6-text-1\" class=\"halfScale 6-text-1 6-text\" style=\"top:143px;left:601px\"\n          src=\"/120/es/static/_content/6-text-1.png\">\n        <img id=\"6-text-2\" class=\"halfScale 6-text-2 6-text\" style=\"top:143px;left:155px; opacity:0;\"\n          src=\"/120/es/static/_content/6-text-2.png\">\n        \n        <img id=\"6-cta-1\" class=\"halfScale pointer 6-btn\" style=\"top: 697px; left: 599px;transform: scale(0.505);\"\n          onclick=\"toggleText6(false);\" src=\"/120/es/static/_content/6-btn-1.png\">\n        <img id=\"6-cta-2\" class=\"halfScale pointer 6-btn\" style=\"top: 697px; left: 813px;transform: scale(0.505);opacity:0\"\n          onclick=\"toggleText6(true);\" src=\"/120/es/static/_content/6-btn-2.png\">\n\n        <img id=\"6-next\" class=\"halfScale pointer\" style=\"top:719px;right:-80px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-pad-navy.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "mobileHtml": "\n        <h2 id=\"together-we-are-fencing\">Juntos estamos esgrima</h2>\n        <img src=\"/120/es/static/_content/6-mobile-1.jpg\">\n        <p>  <strong>Estimados Amigos:</strong></p>\n        <p>  Nos complace presentarles este n\xFAmero de Escrime, que abarca el mundo de la\n          esgrima y su nueva fase de prosperidad a nivel mundial. En estos momentos de\n          extrema dificultad, la FIE expresa su deseo de que, una vez m\xE1s, la paz\n          prevalezca en el mundo y, como familia mundial, nos unamos para ayudar a\n          aquellos que m\xE1s lo necesitan. El deporte representa una herramienta poderosa\n          para generar la paz, la reconciliaci\xF3n y el entendimiento necesarios para\n          conseguir un acercamiento entre personas. Podemos y deber\xEDamos vivir en paz.\n        </p>\n        <p>  Tambi\xE9n hemos tenido que lidiar con una pandemia mundial durante los dos\n          \xFAltimos a\xF1os. Durante este periodo, la FIE y sus federaciones nacionales\n          trabajaron para garantizar que nuestros eventos pudieran celebrarse de la\n          manera m\xE1s segura posible. Como resultado, las competiciones de la Copa del\n          mundo y de los Grandes premios comenzaron a celebrarse con \xE9xito y continuar\xE1n\n          a lo largo del a\xF1o, durante el cual se llevar\xE1n a cabo numerosas pruebas. Del\n          mismo modo, acabamos de finalizar los Campeonatos del mundo de esgrima juniors\n          y cadetes 2022 en Dub\xE1i, donde 1357 esgrimistas de 103 pa\xEDses, m\xE1s que nunca\n          en nuestra historia, se reunieron durante nueve d\xEDas de competencia pac\xEDfica\n          pero emocionante. </p>\n        <p>  Pr\xF3ximamente, los Campeonatos del mundo de esgrima s\xE9nior dar\xE1n la bienvenida\n          a los Campeonatos del mundo veteranos en octubre. </p>\n        <p>  Tras el clamoroso \xE9xito de la esgrima en los Juegos Ol\xEDmpicos de Tokio de\n          2020, considero que nos encontramos en una posici\xF3n m\xE1s s\xF3lida que nunca para\n          continuar desarrollando nuestra estrategia y para aumentar la popularidad de\n          nuestro deporte, poniendo la vista en los pr\xF3ximos Juegos Ol\xEDmpicos de Par\xEDs\n          de 2024. El notable desarrollo de la esgrima ha quedado atestiguado en las\n          redes sociales y en la televisi\xF3n. Asimismo, la participaci\xF3n a nivel mundial\n          muestra claramente que estamos en el camino correcto para seguir promoviendo\n          nuestro deporte.</p>\n        <p>  Este es el momento de volverse ingenioso e innovador con el fin de crear una\n          esgrima a diferentes niveles para generar entusiasmo y aumentar la conciencia\n          en todo el mundo. Hemos de continuar con el impulso de los \xFAltimos a\xF1os para\n          evolucionar con fuerza, entusiasmo y optimismo. </p>\n        <p>  Os invito a todos a asumir vuestra funci\xF3n como embajadores de nuestro\n          deporte, para que as\xED nos volvamos m\xE1s fuertes y destaquemos a\xFAn m\xE1s dentro de\n          nuestras comunidades y en las salas de esgrima. Ya se\xE1is atletas,\n          entrenadores, funcionarios, voluntarios o seguidores, todos vosotros\n          desempe\xF1\xE1is un papel de enorme importancia como parte del \xE9xito de la esgrima\n          a nivel mundial; un papel que no puede ser infravalorado. </p><p>En nombre de la FIE, nos gustar\xEDa daros las gracias por vuestro continuo\n          apoyo. Espero que disfrut\xE9is de un saludable y pr\xF3spero 2022. </p>\n        <p>  Emmanuel Katsiadakis<br><strong>Presidente interino</strong></p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg6Anim = new TimelineMax();\n          pg6Anim\n            .fromTo(cOf(\"6-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(idOf(\"6-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n\n        function toggleText6(bool){\n          var text1 = idOf(\"6-text-1\");\n          var text2 = idOf(\"6-text-2\");\n          \n          if(!bool && text1.style.opacity == \"0\"){\n            pg6Anim.play();\n            TweenMax.fromTo(text1, 0.5, {opacity:0}, {opacity:1});\n            TweenMax.fromTo(text2, 0.5, {opacity:1}, {opacity:0});\n            TweenMax.fromTo(idOf(\"6-cta-1\"), 0.5, {opacity:0}, {opacity:1});\n            TweenMax.fromTo(idOf(\"6-cta-2\"), 0.5, {opacity:1}, {opacity:0});\n            TweenMax.fromTo(idOf(\"6-img\"), 0.5, {opacity:0}, {opacity:1});\n            TweenMax.fromTo(idOf(\"6-title\"), 0.5, {opacity:0}, {opacity:1});\n          }else if(bool && text2.style.opacity == \"0\"){\n            pg6Anim.pause();\n            TweenMax.fromTo(text1, 0.5, {opacity:1}, {opacity:0});\n            TweenMax.fromTo(text2, 0.5, {opacity:0}, {opacity:1});\n            TweenMax.fromTo(idOf(\"6-cta-1\"), 0.5, {opacity:1}, {opacity:0});\n            TweenMax.fromTo(idOf(\"6-cta-2\"), 0.5, {opacity:0}, {opacity:1});\n            TweenMax.fromTo(idOf(\"6-img\"), 0.5, {opacity:1}, {opacity:0});\n            TweenMax.fromTo(idOf(\"6-title\"), 0.5, {opacity:1}, {opacity:0});\n          }\n        }\n\n        function onPageLeave() {\n          pg6Anim.stop();\n          resetNumbers(\"6-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "PRÓLO GO  Estimados Amigos: Nos complace presentarles este número de Escrime, que abarca el mundo de la esgrima y su nueva fase de prosperidad a nivel mundial. En estos momentos de extrema dificultad, la FIE expresa su deseo de que, una vez más, la paz prevalezca en el mundo y, como familia mundial, nos unamos para ayudar a aquellos que más lo necesitan. El deporte representa una herramienta poderosa para generar la paz, la reconciliación y el entendimiento necesarios para conseguir un acercamiento entre personas. Podemos y deberíamos vivir en paz.  JUNTOS ESTAMOS ESGRIMA  También hemos tenido que lidiar con una pandemia mundial durante los dos últimos años. Durante este periodo, la FIE y sus federaciones nacionales trabajaron para garantizar que nuestros eventos pudieran celebrarse de la manera más segura posible. Como resultado, las competiciones de la Copa del mundo y de los Grandes premios comenzaron a celebrarse con éxito y continuarán  PÁGINA 1  PÁGINA 2  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://shop.pbtfencing.com/\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 21px; right: 723px; width: 193px; height: 38px;\"></div>\n        </a>\n        <a href=\"mailto:sales@pbtfencing.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:21px;right:505px;width:205px;height:38px;\"></div>\n        </a>\n        <a href=\"https://www.instagram.com/pbt_fencing\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 21px; right: 259px; width: 236px; height: 38px;\"></div>\n        </a>\n      ",
    "mobileHtml": "\n        <a href=\"https://shop.pbtfencing.com/\" target=\"_blank\">\n          <img src=\"/120/es/static/_content/7-mobile-1.jpg\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 8-title\" style=\"top:127px;left:65px;\" src=\"/120/es/static/_content/8-title-1.png\">\n        <img class=\"abs halfScale 8-sub\" style=\"top:326px;left:97px;\" src=\"/120/es/static/_content/8-sub-1.png\">\n        <img class=\"abs halfScale 8-line\" style=\"top:328px;left:64px;\" src=\"/120/es/static/_content/8-line-1.png\">\n        <img id=\"8-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2\n          id=\"usa-s-gassner-italy-s-cammilletti-win-tashkent-satellite-foil-tournament\">El estadounidense Gassner y la italiana Cammilletti ganan el Torneo Sat\xE9lite\n          de Florete de Tashkent </h2>\n        <img src=\"/120/es/static/_content/8-mobile-1.jpg\">\n        <p><strong>    Tashkent, Uzbekist\xE1n<br>29 de septiembre de 2021</strong></p>\n        <p><strong>    El estadounidense Ethan Gassner y la italiana Marta Cammilletti ganaron las\n            medallas de oro masculina y femenina en el Torneo Sat\xE9lite Internacional de\n            Florete de Tashkent, Uzbekist\xE1n, que se celebr\xF3 los d\xEDas 25 y 26 de\n            septiembre.</strong></p>\n        <p>  Participaron cuarenta y ocho atletas de diferentes pa\xEDses, incluidos\n          Bielorrusia, Ir\xE1n, Irak, Italia, Kazajst\xE1n, Filipinas, Turqu\xEDa, EE. UU. y\n          Uzbekist\xE1n. </p>\n        <p>  En florete masculino individual, Gassner gan\xF3 frente al bielorruso Uladzislau\n          Kurylovich por 15-10. Las medallas de bronce fueron para Akhmadillokhon\n          Solikhojiev (UZB) y Mukhammad Yusuf Asranov (UZB). </p>\n        <p>  En florete femenino individual, Cammilletti gan\xF3 frente a la filipina Maxine\n          Isabel Esteban por 15-2. Las medallas de bronce fueron para Madinabonu\n          Parpieva (UZB) y Umida Ilyosova (UZB). </p>\n        <p>  El evento se celebr\xF3 de conformidad con las normas de la FIE y el protocolo de\n          COVID-19.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg8Anim = new TimelineMax();\n          pg8Anim\n            .fromTo(cOf(\"8-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"8-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"8-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"8-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg8Anim.stop();\n          resetNumbers(\"8-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "DEP ORTE  EL ESTADOUNIDENSE GASSNER Y LA ITALIANA CAMMILLETTI GANAN EL TORNEO SATÉLITE DE FLORETE DE TASHKENT TASHKENT, UZBEKISTÁN 29 DE SEPTIEMBRE DE 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/es/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/es/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"9-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg9Anim = new TimelineMax();\n          pg9Anim\n            .fromTo(idOf(\"9-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg9Anim.stop();\n          resetNumbers(\"9-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "TORNEO SATÉLITE DE FLORETE TASHKENT, UZBEKISTÁN 2/2  El estadounidense Ethan Gassner y la italiana Marta Cammilletti ganaron las medallas de oro masculina y femenina en el Torneo Satélite Internacional de Florete de Tashkent, Uzbekistán, que se celebró los días 25 y 26 de septiembre. Participaron cuarenta y ocho atletas de diferentes países, incluidos Bielorrusia, Irán, Irak, Italia, Kazajstán, Filipinas, Turquía, EE. UU. y Uzbekistán. En florete masculino individual, Gassner ganó frente al bielorruso Uladzislau Kurylovich por 15-10. Las medallas de bronce fueron para Akhmadillokhon Solikhojiev (UZB) y Mukhammad Yusuf Asranov (UZB). En florete femenino individual, Cammilletti ganó frente a la filipina Maxine Isabel Esteban por 15-2. Las medallas de bronce fueron para Madinabonu Parpieva (UZB) y Umida Ilyosova (UZB). El evento se celebró de conformidad con las normas de la FIE y el protocolo de COVID-19. ■  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 10-title\" style=\"top:99px;left:424px;\" src=\"/120/es/static/_content/10-title-1.png\">\n        <img class=\"abs halfScale 10-sub\" style=\"top:309px;left:456px;\" src=\"/120/es/static/_content/10-sub-1.png\">\n        <img class=\"abs halfScale 10-line\" style=\"top:308px;left:423px;\" src=\"/120/es/static/_content/10-line-1.png\">\n        <img id=\"10-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2 id=\"korea-s-kim-greece-s-georgiadou-win-2021-orleans-sabre-grand-prix\">El coreano Kim y la griega Georgiadou ganan el oro en el Gran Premio de Sable de Orleans de 2021</h2>\n        <img src=\"/120/es/static/_content/10-mobile-1.jpg\">\n        <p><strong>Orleans, Francia<br>13 de noviembre de 2021</strong></p>\n        <p><strong>En el primer Gran Premio de la FIE de la temporada de competencias 2021-2022, el campe\xF3n mundial coreano Junghwan Kim y la griega Despina Georgiadou ganaron las pruebas individuales masculina y femenina del Gran Premio de Sable de Orleans. </strong></p>\n        <p>Las finales se celebraron en el recinto deportivo Z\xE9nith d'Orl\xE9ans, y participaron en la competencia general 170 hombres y 162 mujeres.</p>\n        <p>En la final de la prueba de sable masculino, Kim se enfrent\xF3 al italiano Luca Curatoli, ganando la medalla de oro por 15-3. Curatoli derrot\xF3 al japon\xE9s Kento Yoshida en la semifinal, por 15-10, y Kim venci\xF3 a su compa\xF1ero de equipo y campe\xF3n mundial Sanguk Oh, por 15-13.</p>\n        <p>En la final de la prueba de sable femenino, Georgiadou derrot\xF3 a su compa\xF1era de  equipo, Theodora Gkountoura, por un solo punto, por 15-14, para hacerse con el oro. Gkountoura venci\xF3 a la coreana Jisu Yoon en la semifinal, por 15-12, y Georgiadou se impuso a la rusa Svetlana Sheveleva, por 15-12. Cabe destacar que en cuartos de final Yoon venci\xF3 a su compa\xF1era de equipo y campeona ol\xEDmpica Jiyeon Kim, por 15-13.</p>\n        <p>La clasificaci\xF3n final de sable masculino fue la siguiente: Junghwan Kim (KOR, oro), Luca Curatoli (ITA, plata), Sanguk Oh (KOR, bronce), Kento Yoshida (JPN, bronce), Sandro Bazadze (GEO), Junho Kim (KOR), Andriy Yagodka (UKR) y Enver Yildirim (TUR).</p>\n        <p>La clasificaci\xF3n final de sable femenino fue la siguiente: Despina Georgiadou (GRE, oro), Theodora Gkountoura (GRE, plata), Svetlana Sheveleva (RUS, bronce), Jisu Yoon (KOR, bronce), Manon Apithy-Brunet (FRA), Liza Pusztai (HUN), Jiyeon Kim (KOR) y Amalia Aime (FRA).</p>\n        <p>Los resultados completos y oficiales de la prueba se pueden encontrar aqu\xED en la p\xE1gina web de la FIE. Para tener m\xE1s noticias y ver reportajes emocionantes sobre la esgrima mundial, consulte la serie de v\xEDdeos de la FIE en nuestro canal de YouTube.</p>\n        <p>Haga clic aqu\xED para volver a ver los encuentros masculinos y femeninos del Gran Premio de Sable de Orleans.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg10Anim = new TimelineMax();\n          pg10Anim\n            .fromTo(cOf(\"10-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"10-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"10-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"10-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg10Anim.stop();\n          resetNumbers(\"10-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "DEP ORTE  EL COREANO KIM Y LA GRIEGA GEORGIADOU GANAN EL ORO EN EL GRAN PREMIO DE SABLE DE ORLEANS DE 2021 ORLEANS, FRANCIA 13 DE NOVIEMBRE DE 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/es/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/es/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"11-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-edge-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg11Anim = new TimelineMax();\n          pg11Anim\n            .fromTo(idOf(\"11-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg11Anim.stop();\n          resetNumbers(\"11-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "GRAN PREMIO DE SABLE ORLEANS, FRANCIA 2/3  En el primer Gran Premio de la FIE de la temporada de competencias 2021-2022, el campeón mundial coreano Junghwan Kim y la griega Despina Georgiadou ganaron las pruebas individuales masculina y femenina del Gran Premio de Sable de Orleans. Las finales se celebraron en el recinto deportivo Zénith d'Orléans, y participaron en la competencia general 170 hombres y 162 mujeres. En la final de la prueba de sable masculino, Kim se enfrentó al italiano Luca Curatoli, ganando la medalla de oro por 15-3. Curatoli derrotó al japonés Kento Yoshida en la semifinal, por 1510, y Kim venció a su compañero de equipo y campeón mundial Sanguk Oh, por 15-13. En la final de la prueba de sable femenino, Georgiadou derrotó a su compañera de equipo, Theodora Gkountoura, por un solo punto, por 15-14, para hacerse con el oro. Gkountoura venció a la coreana Jisu Yoon en la semifinal, por 15-12, y Georgiadou se impuso a la rusa Svetlana Sheveleva, por 15-12. Cabe destacar que en cuartos de final Yoon venció a"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/es/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/es/static/_content/fb-red.png\">\n        </a>\n        \n        <a href=\"https://fie.org/competitions/2022/158\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"bottom: 412px; right: 152px; width: 57px; height: 20px;\"></div>\n          <div class=\"addContentLink\" style=\"bottom: 389px; right: 412px; width: 113px; height: 20px;\"></div>\n        </a> \n        \n        <a href=\"https://www.youtube.com/c/FIEvideo\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"bottom: 318px; right: 288px; width: 146px; height: 21px;\"></div>\n        </a>\n        \n        <a href=\"https://www.youtube.com/c/FIEvideo/videos\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"bottom: 271px; right: 407px; width: 119px; height: 21px;\"></div>\n        </a>\n\n        <img id=\"12-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg12Anim = new TimelineMax();\n          pg12Anim\n            .fromTo(idOf(\"12-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg12Anim.stop();\n          resetNumbers(\"12-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "GRAN PREMIO DE SABLE ORLEANS, FRANCIA 3/3  su compañera de equipo y campeona olímpica Jiyeon Kim, por 15-13. La clasificación final de sable masculino fue la siguiente: Junghwan Kim (KOR, oro), Luca Curatoli (ITA, plata), Sanguk Oh (KOR, bronce), Kento Yoshida (JPN, bronce), Sandro Bazadze (GEO), Junho Kim (KOR), Andriy Yagodka (UKR) y Enver Yildirim (TUR).  Los resultados completos y oficiales de la prueba se pueden encontrar aquí en la página web de la FIE. Para tener más noticias y ver reportajes emocionantes sobre la esgrima mundial, consulte la serie de vídeos de la FIE en nuestro canal de YouTube. Haga clic aquí para volver a ver los encuentros masculinos y femeninos del Gran Premio de Sable de Orleans. ■  La clasificación final de sable femenino fue la siguiente: Despina Georgiadou (GRE, oro), Theodora Gkountoura (GRE, plata), Svetlana Sheveleva (RUS, bronce), Jisu Yoon (KOR, bronce), Manon Apithy-Brunet (FRA), Liza Pusztai (HUN), Jiyeon Kim (KOR) y Amalia Aime (FRA). W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "\n        <a href=\"mailto:lammet@mail.ru\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 317px; right: 113px; width: 197px; height: 24px;\"></div> </a>\n        <a href=\"https://www.lammet.ru\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 292px; right: 177px; width: 132px; height: 24px;\"></div> </a>\n      ",
    "mobileHtml": "\n        <a href=\"https://www.lammet.ru\" target=\"_blank\">\n          <img src=\"/120/es/static/_content/13-mobile-1.jpg\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 14-title\" style=\"top:70px;left:64px;\" src=\"/120/es/static/_content/14-title-1.png\">\n        <img class=\"abs halfScale 14-sub\" style=\"top:220px;left:97px;\" src=\"/120/es/static/_content/14-sub-1.png\">\n        <img class=\"abs halfScale 14-line\" style=\"top:223px;left:64px;\" src=\"/120/es/static/_content/14-line-1.png\">\n        <img id=\"14-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2\n          id=\"france-s-jacques-andre-coquin-and-team-russia-win-glaive-de-tallinn-women-s-epee-world-cup\">\n          La francesa Jacques Andre Coquin y el equipo ruso ganan la Copa del mundo de espada femenina \xABGlaive de Tallinn\xBB</h2>\n        <img src=\"/120/es/static/_content/14-mobile-1.jpg\">\n        <p><strong>Tall\xEDn, Estonia<br>19-21 de Noviembre de 2021</strong></p>\n        <p>La francesa Josephine Jacques Andre Coquin gan\xF3 la medalla de oro individual, y Rusia obtuvo el oro en la competici\xF3n por equipos en la 51\xAA Copa del mundo de espada femenina \xABGlaive de Tallinn\xBB.  </p>\n        <p>Con 246 esgrimistas de espada femenina y 26 equipos en la competici\xF3n, se celebr\xF3 la primera Copa del mundo senior femenina de la FIE de la temporada de competici\xF3n 2021-2022. El evento se celebr\xF3 en el complejo deportivo Kalev Sports Hall.</p>\n        <p>En espada femenina individual, Jacques Andre Coquin se enfrent\xF3 a su compa\xF1era de equipo Marie-Florence Candassamy en el encuentro final, ganando con una puntuaci\xF3n de 15-11. Candassamy venci\xF3 a la italiana Federica Isola en la ronda de semifinales por 15-9, y Jacques Andre Coquin derrot\xF3 a su compa\xF1era de equipo, Alexandra Louis Marie, por 15-11.</p>\n        <p>En espada femenina por equipos, Rusia gan\xF3 frente a Alemania, con una puntuaci\xF3n de 43-37. Alemania venci\xF3 a Italia en la ronda de semifinales por 32-31, y Rusia derrot\xF3 a Corea por 45-35. Italia obtuvo la medalla de bronce frente a Corea por 45-33.</p>\n        <p>La clasificaci\xF3n final de espada femenina individual estuvo formada por Josephine Jacques Andre Coquin (FRA, oro), Marie-Florence Candassamy (FRA, plata), Federica Isola (ITA, bronce), Alexandra Louis Marie (FRA, bronce), Renata Knapik-Miazga (POL), Aliya Luty (FRA), Anna Van Brummen (USA) y Lauren Rembi (FRA).</p>\n        <p>La clasificaci\xF3n final de espada femenina por equipos la lider\xF3 Rusia (oro), Alemania (plata), Italia (bronce), Corea, Estonia, Suiza, Francia y Polonia.</p>\n        <p>Puede consultar todos los resultados oficiales del evento aqu\xED, en la p\xE1gina web de la FIE. Para acceder a m\xE1s noticias y art\xEDculos emocionantes de la esgrima a nivel mundial, vea los v\xEDdeos de la FIE en el Canal de esgrima de la FIE en YouTube.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg14Anim = new TimelineMax();\n          pg14Anim\n            .fromTo(cOf(\"14-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"14-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"14-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"14-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg14Anim.stop();\n          resetNumbers(\"14-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "DEP ORTE  LA FRANCESA JACQUES ANDRE COQUIN Y EL EQUIPO RUSO GANAN LA COPA DEL MUNDO DE ESPADA FEMENINA «GLAIVE DE TALLINN» TALLÍN, ESTONIA 19-21 DE NOVIEMBRE DE 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/es/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/es/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"15-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-edge-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg15Anim = new TimelineMax();\n          pg15Anim\n            .fromTo(idOf(\"15-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg15Anim.stop();\n          resetNumbers(\"15-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "COPA DEL MUNDO DE ESPADA FEMENINA TALLÍN, ESTONIA 2/3  La francesa Josephine Jacques Andre Coquin ganó la medalla de oro individual, y Rusia obtuvo el oro en la competición por equipos en la 51ª Copa del mundo de espada femenina «Glaive de Tallinn». Con 246 esgrimistas de espada femenina y 26 equipos en la competición, se celebró la primera Copa del mundo senior femenina de la FIE de la temporada de competición 20212022. El evento se celebró en el complejo deportivo Kalev Sports Hall.  En espada femenina individual, Jacques Andre Coquin se enfrentó a su compañera de equipo Marie-Florence Candassamy en el encuentro final, ganando con una puntuación de 15-11. Candassamy venció a la italiana Federica Isola en la ronda de semifinales por 15-9, y Jacques Andre Coquin derrotó a su compañera de equipo, Alexandra Louis Marie, por 15-11. En espada femenina por equipos, Rusia ganó frente a Alemania, con una puntuación de 43-37. Alemania venció a Italia en la ronda de"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/es/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/es/static/_content/fb-red.png\">\n        </a>\n        \n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"  bottom: 271px; right: 152px; width: 282px; height: 22px;\"></div>\n        </a>\n        \n        <a href=\"https://www.youtube.com/c/FIEvideo\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"  bottom: 200px; right: 150px; width: 147px; height: 22px;\"></div>\n          <div class=\"addContentLink\"\n            style=\"bottom: 179px; right: 347px; width: 179px; height: 22px;\"></div>\n        </a>\n\n        <img id=\"16-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg16Anim = new TimelineMax();\n          pg16Anim\n            .fromTo(idOf(\"16-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg16Anim.stop();\n          resetNumbers(\"16-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "COPA DEL MUNDO DE ESPADA FEMENINA TALLÍN, ESTONIA 3/3  semifinales por 32-31, y Rusia derrotó a Corea por 45-35. Italia obtuvo la medalla de bronce frente a Corea por 45-33. La clasificación final de espada femenina individual estuvo formada por Josephine Jacques Andre Coquin (FRA, oro), MarieFlorence Candassamy (FRA, plata), Federica Isola (ITA, bronce), Alexandra Louis Marie (FRA, bronce), Renata Knapik-Miazga (POL), Aliya Luty (FRA), Anna Van Brummen (USA) y Lauren Rembi (FRA). La clasificación final de espada femenina por equipos la lideró Rusia (oro), Alemania (plata), Italia (bronce), Corea, Estonia, Suiza, Francia y Polonia. Puede consultar todos los resultados oficiales del evento aquí, en la página web de la FIE. Para acceder a más noticias y artículos emocionantes de la esgrima a nivel mundial, vea los vídeos de la FIE en el Canal de esgrima de la FIE en YouTube. ■  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 17-title\" style=\"top:57px;left:66px;\" src=\"/120/es/static/_content/17-title-1.png\">\n        <img class=\"abs halfScale 17-sub\" style=\"top:216px;left:97px;\" src=\"/120/es/static/_content/17-sub-1.png\">\n        <img class=\"abs halfScale 17-line\" style=\"top:214px;left:64px;\" src=\"/120/es/static/_content/17-line-1.png\">\n        <img id=\"17-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2 id=\"venezuela-s-limardo-gascon-team-russia-win-bern-men-s-epee-world-cup\">\n          El venezolano Limardo Gasc\xF3n y el equipo de Rusia ganan la Copa del mundo de espada masculina en Berna</h2>\n        <img src=\"/120/es/static/_content/17-mobile-1.jpg\">\n        <p>\u200B\u200B<strong>Berna, Suiza<br>19-21 de noviembre de 2021</strong></p>\n        <p><strong>El campe\xF3n ol\xEDmpico de Venezuela Rub\xE9n Limardo Gasc\xF3n gan\xF3 la medalla de oro individual, y Rusia obtuvo el oro en la competici\xF3n por equipos en la Copa del mundo de espada masculina de Berna. </strong></p>\n        <p>Con 265 esgrimistas de espada y 33 equipos en la competici\xF3n, se celebr\xF3 la primera Copa del mundo senior masculina de la FIE de la temporada de competici\xF3n 2021-2022. El evento se celebr\xF3 en el estadio Wankdorf de Berna.</p>\n        <p>En espada masculina individual, Limardo Gasc\xF3n se enfrent\xF3 al franc\xE9s Alexandre Bardenet en el encuentro final, ganando con una puntuaci\xF3n de 15-7. Bardenet derrot\xF3 a su compa\xF1ero de equipo y medallista ol\xEDmpico de oro Romain Cannone en la ronda de semifinales por 15-9, y Limardo Gasc\xF3n venci\xF3 al italiano Andrea Santarelli por un solo toque, con una puntuaci\xF3n de 10-9. Bardenet tambi\xE9n gan\xF3 a su compa\xF1ero de equipo y campe\xF3n mundial Yannick Borel en cuartos de final por 15-9.</p>\n        <p>En espada masculina por equipos, Rusia gan\xF3 por un solo punto frente a Espa\xF1a, con una puntuaci\xF3n de 45-44. Espa\xF1a venci\xF3 a Hungr\xEDa en la ronda de semifinales por 45-42, y Rusia derrot\xF3 a Jap\xF3n por 45-34. Jap\xF3n obtuvo la medalla de bronce frente a Hungr\xEDa por 45-34.</p>\n        <p>La clasificaci\xF3n final de espada masculina individual estuvo compuesta por Rub\xE9n Limardo Gasc\xF3n (VEN, oro), Alexandre Bardenet (FRA, plata), Romain Cannone (FRA, bronce), Andrea Santarelli (ITA, bronce), Daniel Berta (HUN), Koki Kano (JPN), Alex Fava (FRA) y Georgiy Bruev (RUS).</p>\n        <p>La clasificaci\xF3n final de espada masculina por equipos estuvo liderada por Rusia (oro), Espa\xF1a (plata), Jap\xF3n (bronce), Hungr\xEDa, Francia, Ucrania, Dinamarca e Italia.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg17Anim = new TimelineMax();\n          pg17Anim\n            .fromTo(cOf(\"17-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"17-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"17-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"17-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg17Anim.stop();\n          resetNumbers(\"17-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "DEP ORTE  EL VENEZOLANO LIMARDO GASCÓN Y EL EQUIPO DE RUSIA GANAN LA COPA DEL MUNDO DE ESPADA MASCULINA EN BERNA BERNA, SUIZA 19-21 DE NOVIEMBRE DE 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/es/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/es/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"18-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg18Anim = new TimelineMax();\n          pg18Anim\n            .fromTo(idOf(\"18-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg18Anim.stop();\n          resetNumbers(\"18-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "COPA DEL MUNDO DE ESPADA MASCULINA BERNA, SUIZA 2/2  VeEl campeón olímpico de Venezuela Rubén Limardo Gascón ganó la medalla de oro individual, y Rusia obtuvo el oro en la competición por equipos en la Copa del mundo de espada masculina de Berna. Con 265 esgrimistas de espada y 33 equipos en la competición, se celebró la primera Copa del mundo senior masculina de la FIE de la temporada de competición 2021-2022. El evento se celebró en el estadio Wankdorf de Berna. En espada masculina individual, Limardo Gascón se enfrentó al francés Alexandre Bardenet en el  encuentro final, ganando con una puntuación de 15-7. Bardenet derrotó a su compañero de equipo y medallista olímpico de oro Romain Cannone en la ronda de semifinales por 159, y Limardo Gascón venció al italiano Andrea Santarelli por un solo toque, con una puntuación de 10-9. Bardenet también ganó a su compañero de equipo y campeón mundial Yannick Borel en cuartos de final por 15-9. En espada masculina por equipos, Rusia ganó por un solo punto frente a España, con una puntuación de 45-44. España venció a Hungría en la ronda de semifinales por 45-42, y Rusia derrotó a Japón por 45-34. Japón obtuvo la medalla de bronce frente a Hungría por 45-34. La clasificación final de espada masculina individual estuvo compuesta por Rubén Limardo Gascón (VEN, oro), Alexandre Bardenet (FRA, plata), Romain Cannone (FRA, bronce), Andrea Santarelli (ITA, bronce), Daniel Berta (HUN), Koki Kano (JPN), Alex Fava (FRA) y Georgiy Bruev (RUS). La clasificación final de espada masculina por equipos estuvo liderada por Rusia (oro), España (plata), Japón (bronce), Hungría, Francia, Ucrania, Dinamarca e Italia. ■ W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "",
    "mobileHtml": "\n        <img src=\"/120/es/static/_content/19-mobile-1.jpg\">\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 20-title\" style=\"top:64px;left:487px;\" src=\"/120/es/static/_content/20-title-1.png\">\n        <img class=\"abs halfScale 20-sub\" style=\"top:263px;left:519px;\" src=\"/120/es/static/_content/20-sub-1.png\">\n        <img class=\"abs halfScale 20-line\" style=\"top:266px;left:487px;\" src=\"/120/es/static/_content/20-line-1.png\">\n        <img id=\"20-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2\n          id=\"italy-s-alice-volpi-and-team-italy-win-gold-at-st-maur-women-s-foil-world-cup\">\n          La italiana Alice Volpi y el equipo de Italia ganan el oro en la Copa del Mundo de florete femenino\n        </h2>\n        <img src=\"/120/es/static/_content/20-mobile-1.jpg\">\n        <p><strong>Saint-Maur-Des-Foss\xE9s, Francia<br>10-12 de diciembre de 2021 </strong></p>\n        <p><strong>La campeona del mundo Alice Volpi gan\xF3 la medalla de oro individual e Italia se llev\xF3 el oro en la prueba por equipos de la Copa del Mundo de florete femenino de Saint Maur.</strong></p>\n        <p>La prueba se celebr\xF3 en el Centro Deportivo Pierre Brossolette con la participaci\xF3n de 182 esgrimistas de florete femenino y 20 equipos.</p>\n        <p>Volpi se enfrent\xF3 a la campeona ol\xEDmpica estadounidense Lee Kiefer en el encuentro por la medalla de oro en florete femenino individual, ganando por un solo toque, por 15-14. Kiefer venci\xF3 a su compa\xF1era de equipo, Jacqueline Dubrovich, en la ronda de semifinales, por 15-4, y Volpi tambi\xE9n derrot\xF3 a su compa\xF1era de equipo, Francesca Palumbo, por 15-12.</p>\n        <p>En la prueba de florete femenino por equipos, Italia se llev\xF3 la medalla de oro contra Jap\xF3n en la ronda final y gan\xF3 con un resultado de 43-40. Jap\xF3n venci\xF3 a Rusia en las semifinales, por 31-26, e Italia derrot\xF3 a Canad\xE1, por 45-37. La medalla de bronce fue para Rusia tras derrotar a Canad\xE1, por 44-39.</p>\n        <p>La clasificaci\xF3n en la prueba de florete femenino individual inclu\xEDa a Alice Volpi (ITA, oro), Lee Kiefer (EE. UU, plata), Jacqueline Dubrovich (EE. UU, bronce), Francesca Palumbo (ITA, bronce), Qingyuan Chen (CHN), Martina Batini (ITA), Svetlana Tripapina (RUS) y Kiyeun Kim (KOR).</p>\n        <p>La clasificaci\xF3n en la prueba de florete femenino por equipos inclu\xEDa a Italia (oro), Jap\xF3n (plata), Rusia (bronce), Canad\xE1, Polonia, China, EE. UU. y Hong Kong, China.</p>\n        <p>Los resultados completos y oficiales de la prueba se pueden encontrar aqu\xED en la p\xE1gina web de la FIE. Consulte el canal de esgrima de la FIE en YouTube para ver m\xE1s noticias y reportajes sobre la esgrima mundial.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg20Anim = new TimelineMax();\n          pg20Anim\n            .fromTo(cOf(\"20-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"20-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"20-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"20-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg20Anim.stop();\n          resetNumbers(\"20-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "DEP ORTE  LA ITALIANA ALICE VOLPI Y EL EQUIPO DE ITALIA GANAN EL ORO EN LA COPA DEL MUNDO DE FLORETE FEMENINO SAINT-MAUR-DES-FOSSÉS, FRANCIA 10-12 DE DICIEMBRE DE 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/es/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/es/static/_content/fb-red.png\">\n        </a>\n        \n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"bottom: 131px; right: 151px; width: 142px; height: 20px;\"></div>\n          <div class=\"addContentLink\"\n            style=\"bottom: 107px; right: 404px; width: 122px; height: 20px;\"></div>\n        </a>\n        \n        <a href=\"https://www.youtube.com/c/FIEvideo\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"  bottom: 107px; right: 150px; width: 149px; height: 20px;\"></div>\n          <div class=\"addContentLink\" style=\"  bottom: 84px; right: 347px; width: 179px; height: 20px;\"></div>\n        </a>\n\n        <img id=\"21-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg21Anim = new TimelineMax();\n          pg21Anim\n            .fromTo(idOf(\"21-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg21Anim.stop();\n          resetNumbers(\"21-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "LA COPA DEL MUNDO DE FLORETE FEMENINO SAINT-MAUR-DESFOSSÉS, FRANCIA 2/2  La campeona del mundo Alice Volpi ganó la medalla de oro individual e Italia se llevó el oro en la prueba por equipos de la Copa del Mundo de florete femenino de Saint Maur. La prueba se celebró en el Centro Deportivo Pierre Brossolette con la participación de 182 esgrimistas de florete femenino y 20 equipos. Volpi se enfrentó a la campeona olímpica estadounidense Lee Kiefer en el encuentro por la medalla de oro en florete femenino individual, ganando por un solo toque, por 15-14. Kiefer venció a su compañera de equipo, Jacqueline Dubrovich, en la ronda de semifinales, por 154, y Volpi también derrotó a su compañera de equipo, Francesca Palumbo, por 15-12. En la prueba de florete femenino por equipos, Italia se llevó la medalla de oro contra Japón en la ronda final y ganó con un resultado de 4340. Japón venció a Rusia en las semifinales, por 31-26, e Italia derrotó a Canadá, por 4537. La medalla de bronce fue para Rusia tras derrotar a Canadá, por 44-39. La clasificación en la prueba de florete femenino individual incluía a Alice Volpi (ITA, oro),  Lee Kiefer (EE. UU, plata), Jacqueline Dubrovich (EE. UU, bronce), Francesca Palumbo (ITA, bronce), Qingyuan Chen (CHN), Martina Batini (ITA), Svetlana Tripapina (RUS) y Kiyeun Kim (KOR). La clasificación en la prueba de florete femenino por equipos incluía a Italia (oro), Japón (plata), Rusia (bronce), Canadá, Polonia, China, EE. UU. y Hong Kong, China. Los resultados completos y oficiales de la prueba se pueden encontrar aquí en la página web de la FIE. Consulte el canal de esgrima de la FIE en YouTube para ver más noticias y reportajes sobre la esgrima mundial. ■ W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 22-title\" style=\"top:85px;left:363px;\" src=\"/120/es/static/_content/22-title-1.png\">\n        <img class=\"abs halfScale 22-sub\" style=\"top:285px;left:396px;\" src=\"/120/es/static/_content/22-sub-1.png\">\n        <img class=\"abs halfScale 22-line\" style=\"top:287px;left:363px;\" src=\"/120/es/static/_content/22-line-1.png\">\n        <img id=\"22-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2\n          id=\"hong-kong-s-cheung-team-italy-take-gold-in-challenge-international-de-paris-men-s-foil-world-cup\">\n          Cheung de Hong Kong e Italia por equipos ganan el oro en la Copa del mundo de florete masculino de Par\xEDs</h2>\n        <img src=\"/120/es/static/_content/22-mobile-1.jpg\">\n        <p><strong>Par\xEDs, Francia<br>14-16 de Enero de 2022</strong></p>\n        <p><strong>El campe\xF3n ol\xEDmpico de Hong Kong Ka Long Cheung gan\xF3 la medalla de oro individual e Italia obtuvo el oro en la competici\xF3n por equipos en la Copa del mundo de florete masculino del Challenge Internacional (CIP) de Par\xEDs. </strong></p>\n        <p>En el evento, que se celebr\xF3 en el Stade Pierre de Coubertin, participaron 210 tiradores y 26 equipos.</p>\n        <p>Cheung se enfrent\xF3 al italiano Edoardo Luperi en la ronda final de florete masculino individual, ganando el oro con una puntuaci\xF3n de 15-12. Luperi derrot\xF3 al estadounidense Chase Emmer en la ronda de semifinales por 15-13, mientras que Cheung gan\xF3 al campe\xF3n del mundo italiano Alessio Foconi, por 15-4. Cheung tambi\xE9n gan\xF3 frente al campe\xF3n del mundo franc\xE9s Enzo Lefort en los cuartos de final por 15-9, y en la misma ronda Emmer venci\xF3 al campe\xF3n ol\xEDmpico italiano Daniele Garozzo por 15-5.</p>\n        <p>Italia logr\xF3 el oro en florete masculino por equipos, derrotando a Francia en el encuentro final por 45-20. Francia venci\xF3 a Rusia en la ronda de semifinales por 45-39, mientras que Italia venci\xF3 a EE. UU. por 45-38. EE. UU. obtuvo la medalla de bronce frente a Rusia por 45-31.</p>\n        <p>La clasificaci\xF3n final de florete masculino individual estuvo compuesta por Ka Long Cheung (HKG, oro), Edoardo Luperi (ITA, plata), Chase Emmer (EE. UU., bronce), Alessio Foconi (ITA, bronce), Daniele Garozzo (ITA), Chun Yin Ryan Choi (HKG), Enzo Lefort (FRA) y Alexandre Sido (FRA).</p>\n        <p>La clasificaci\xF3n final de florete masculino por equipos estuvo liderada por Italia (oro), Francia (plata), EE. UU. (bronce), Rusia, Jap\xF3n, Egipto, Corea y Hong Kong, China.</p>\n        <p>Puede consultar todos los resultados oficiales del evento aqu\xED, en la p\xE1gina web de la FIE. Para acceder a m\xE1s noticias y art\xEDculos emocionantes de la esgrima a nivel mundial, vea el Canal de esgrima de la FIE en YouTube.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg22Anim = new TimelineMax();\n          pg22Anim\n            .fromTo(cOf(\"22-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"22-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"22-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"22-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg22Anim.stop();\n          resetNumbers(\"22-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "DEP ORTE  CHEUNG DE HONG KONG E ITALIA POR EQUIPOS GANAN EL ORO EN LA COPA DEL MUNDO DE FLORETE MASCULINO DE PARÍS PARÍS, FRANCIA 14-16 DE ENERO DE 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/es/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/es/static/_content/fb-red.png\">\n        </a>\n        \n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"  bottom: 131px; right: 193px; width: 249px; height: 20px;\"></div>\n        </a>\n        \n        <a href=\"https://www.youtube.com/c/FIEvideo\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"bottom: 85px; right: 149px; width: 77px; height: 20px;\"></div>\n          <div class=\"addContentLink\" style=\"  bottom: 60px; right: 283px; width: 243px; height: 21px;\"></div>\n        </a>\n\n        <img id=\"23-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg23Anim = new TimelineMax();\n          pg23Anim\n            .fromTo(idOf(\"23-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg23Anim.stop();\n          resetNumbers(\"23-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "COPA DEL MUNDO DE FLORETE MASCULINO PARÍS, FRANCIA 2/2  El campeón olímpico de Hong Kong Ka Long Cheung ganó la medalla de oro individual e Italia obtuvo el oro en la competición por equipos en la Copa del mundo de florete masculino del Challenge Internacional (CIP) de París. En el evento, que se celebró en el Stade Pierre de Coubertin, participaron 210 tiradores y 26 equipos. Cheung se enfrentó al italiano Edoardo Luperi en la ronda final de florete masculino individual, ganando el oro con una puntuación de 15-12. Luperi derrotó al estadounidense Chase Emmer en la ronda de semifinales por 15-13, mientras que Cheung ganó al campeón del mundo italiano Alessio Foconi, por 15-4. Cheung también ganó frente al campeón del mundo francés Enzo Lefort en los cuartos de final por 15-9, y en la misma ronda Emmer venció al campeón olímpico italiano Daniele Garozzo por 15-5. Italia logró el oro en florete masculino por equipos, derrotando a Francia en el encuentro final por 45-20. Francia venció a Rusia en la ronda de semifinales por 45-39, mientras  que Italia venció a EE. UU. por 45-38. EE. UU. obtuvo la medalla de bronce frente a Rusia por 45-31. La clasificación final de florete masculino individual estuvo compuesta por Ka Long Cheung (HKG, oro), Edoardo Luperi (ITA, plata), Chase Emmer (EE. UU., bronce), Alessio Foconi (ITA, bronce), Daniele Garozzo (ITA), Chun Yin Ryan Choi (HKG), Enzo Lefort (FRA) y Alexandre Sido (FRA). La clasificación final de florete masculino por equipos estuvo liderada por Italia (oro), Francia (plata), EE. UU. (bronce), Rusia, Japón, Egipto, Corea y Hong Kong, China. Puede consultar todos los resultados oficiales del evento aquí, en la página web de la FIE. Para acceder a más noticias y artículos emocionantes de la esgrima a nivel mundial, vea el Canal de esgrima de la FIE en YouTube. ■ W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.blaise-freres.fr\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"  bottom: 173px; right: 981px; width: 177px; height: 25px; }\"></div>\n        </a>\n      ",
    "mobileHtml": "\n        <a href=\"https://www.blaise-freres.fr\" target=\"_blank\">\n          <img src=\"/120/es/static/_content/pg24.jpg\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 25-title\" style=\"top:60px;left:486px;\" src=\"/120/es/static/_content/25-title-1.png\">\n        <img class=\"abs halfScale 25-sub\" style=\"top:243px;left:770px;\" src=\"/120/es/static/_content/25-sub-1.png\">\n        <img class=\"abs halfScale 25-line\" style=\"top:241px;left:738px;\" src=\"/120/es/static/_content/25-line-1.png\">\n        <img id=\"25-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2 id=\"italy-s-volpi-team-usa-win-gold-at-poznan-women-s-foil-world-cup\">\n          El italiano Volpi y EE. UU. por equipos ganan el oro en la Copa del mundo de florete femenino</h2>\n        <p><strong>Poznan, Polonia<br>14-16 de enero de 2022</strong></p>\n        <img src=\"/120/es/static/_content/25-mobile-1.jpg\">\n        <p><strong>La campeona del mundo italiana Alice Volpi obtuvo la medalla de oro individual, y EE. UU. gan\xF3 el oro por equipos en la Copa del mundo de florete femenino de la Universidad Adam Mickiewicz, Polonia. </strong></p>\n        <p>En el evento, que se celebr\xF3 en el UAM Sport Center, participaron 180 tiradores y 20 equipos.</p>\n        <p>En la ronda final de florete femenino individual, Volpi se enfrent\xF3 a la canadiense Eleanor Harvey, ganando el oro con una puntuaci\xF3n de 15-10. En la ronda de semifinales, Harvey venci\xF3 a la china Qingyuan Chen por 15-7, y Volpi derrot\xF3 a la compa\xF1era de equipo Martina Favaretto por 15-11.</p>\n        <p>En florete femenino por equipos, EE. UU. derrot\xF3 a Jap\xF3n en el encuentro final, ganando el oro con una puntuaci\xF3n de 45-23. Jap\xF3n gan\xF3 frente a Polonia en semifinales por 27-25 y EE. UU. venci\xF3 a Rusia por 45-39. Polonia se llev\xF3 la medalla de bronce tras su victoria frente a Rusia por 44-42.</p>\n        <p>La clasificaci\xF3n de florete femenino individual estuvo compuesta por Alice Volpi (ITA, oro), Eleanor Harvey (CAN, plata), Martina Favaretto (ITA, bronce), Qingyuan Chen (CHN, bronce), Francesca Palumbo (ITA), Kata Kondricz (HUN), Alexandra Sunduchkova (RUS) y Elena Petrova (RUS).</p>\n        <p>La clasificaci\xF3n de florete femenino por equipos estuvo liderada por EE. UU. (oro), Jap\xF3n (plata), Polonia (bronce), Rusia, Italia, China, Francia y Canad\xE1.</p>\n        <p>Puede consultar todos los resultados oficiales del evento aqu\xED, en la p\xE1gina web de la FIE. Para acceder a m\xE1s noticias y art\xEDculos emocionantes de la esgrima a nivel mundial, vea el Canal de esgrima de la FIE en YouTube.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg25Anim = new TimelineMax();\n          pg25Anim\n            .fromTo(cOf(\"25-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"25-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"25-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"25-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg25Anim.stop();\n          resetNumbers(\"25-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "DEP ORTE  EL ITALIANO VOLPI Y EE. UU. POR EQUIPOS GANAN EL ORO EN LA COPA DEL MUNDO DE FLORETE FEMENINO POZNAN, POLONIA 14-16 DE ENERO DE 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/es/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/es/static/_content/fb-red.png\">\n        </a>\n\n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"bottom: 130px; right: 192px; width: 249px; height: 20px;\"></div>\n        </a>\n        \n        <a href=\"https://www.youtube.com/c/FIEvideo\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"  bottom: 85px; right: 149px; width: 79px; height: 20px;\"></div>\n          <div class=\"addContentLink\"\n            style=\"bottom: 60px; right: 282px; width: 244px; height: 21px;\"></div>\n        </a>\n\n        <img id=\"26-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg26Anim = new TimelineMax();\n          pg26Anim\n            .fromTo(idOf(\"26-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg26Anim.stop();\n          resetNumbers(\"26-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "COPA DEL MUNDO DE FLORETE FEMENINO POZNAN, POLONIA 2/2  La campeona del mundo italiana Alice Volpi obtuvo la medalla de oro individual, y EE. UU. ganó el oro por equipos en la Copa del mundo de florete femenino de la Universidad Adam Mickiewicz, Polonia. En el evento, que se celebró en el UAM Sport Center, participaron 180 tiradores y 20 equipos. En la ronda final de florete femenino individual, Volpi se enfrentó a la canadiense Eleanor Harvey, ganando el oro con una puntuación de 15-10. En la ronda de semifinales, Harvey venció a la china Qingyuan Chen por 15-7,  y Volpi derrotó a la compañera de equipo Martina Favaretto por 15-11. En florete femenino por equipos, EE. UU. derrotó a Japón en el encuentro final, ganando el oro con una puntuación de 45-23. Japón ganó frente a Polonia en semifinales por 2725 y EE. UU. venció a Rusia por 45-39. Polonia se llevó la medalla de bronce tras su victoria frente a Rusia por 44-42. La clasificación de florete femenino individual estuvo compuesta por Alice Volpi (ITA, oro), Eleanor Harvey (CAN, plata), Martina Favaretto (ITA, bronce), Qingyuan Chen (CHN, bronce), Francesca Palumbo (ITA), Kata Kondricz (HUN), Alexandra Sunduchkova (RUS) y Elena Petrova (RUS). La clasificación de florete femenino por equipos estuvo liderada por EE. UU. (oro), Japón (plata), Polonia (bronce), Rusia, Italia, China, Francia y Canadá. Puede consultar todos los resultados oficiales del evento aquí, en la página web de la FIE. Para acceder a más noticias y artículos emocionantes de la esgrima a nivel mundial, vea el Canal de esgrima de la FIE en YouTube. ■ W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 27-title\" style=\"top:64px;left:454px;\" src=\"/120/es/static/_content/27-title-1.png\">\n        <img class=\"abs halfScale 27-sub\" style=\"top:265px;left:487px;\" src=\"/120/es/static/_content/27-sub-1.png\">\n        <img class=\"abs halfScale 27-line\" style=\"top:262px;left:454px;\" src=\"/120/es/static/_content/27-line-1.png\">\n        <img id=\"27-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n      <h2\n        id=\"georgia-s-bazadze-france-s-queroli-teams-korea-and-france-win-gold-at-tbilisi-sabre-world-cup\">\n        Bazadze, Queroli, y los equipos de Corea y Francia ganan el oro en la Copa del mundo de sable</h2>\n        <p><strong>Tbilisi, Georgia<br>14-18 de enero de 2022</strong></p>\n        <img src=\"/120/es/static/_content/27-mobile-1.jpg\">\n        <p><strong>Sandro Bazadze de Georgia y Caroline Queroli de Francia obtuvieron las medallas de oro individuales, ganando Corea y Francia las competiciones masculinas y femeninas por equipos en la Copa del mundo de sable en Tbilisi. </strong></p>\n        <p>En el evento, que se celebr\xF3 en el Palacio Ol\xEDmpico, compitieron 188 hombres y 154 mujeres, as\xED como 24 equipos masculinos y 25 equipos femeninos.</p>\n        <p>Bazadze se enfrent\xF3 al ruso Kamil Ibragimov en el encuentro final de sable masculino individual, al que gan\xF3 con una puntuaci\xF3n de 15-8. Ibragimov venci\xF3 al campe\xF3n mundial coreano Junghwan Kim en la ronda de semifinales por 15-12, mientras que Bazadze gan\xF3 frente al franc\xE9s Bolade Apithy, por 15-10. Apithy derrot\xF3 al campe\xF3n mundial coreano Sanguk Oh en los cuartos de final por 15-8, y Kim gan\xF3 al campe\xF3n mundial h\xFAngaro Andras Szatmari en la misma ronda por 15-12.</p>\n        <p>Queroli gan\xF3 frente a la griega Theodora Gkountoura en el encuentro final de sable femenino individual por 15-12. Gkountoura venci\xF3 a la campeona ol\xEDmpica rusa Yana Egorian en semifinales por 15-14, mientras que Queroli derrot\xF3 a la italiana Rossella Gregorio por 15-14.</p>\n        <p>En sable masculino por equipos, Corea gan\xF3 frente a Alemania en el encuentro final por 45-38. Alemania venci\xF3 a Italia en la ronda de semifinales por 45-43, mientras que Corea venci\xF3 a Rusia por 45-44. La medalla de bronce fue para Rusia despu\xE9s de ganar a Italia por 45-40.</p>\n        <p>En sable femenino por equipos, Francia consigui\xF3 la medalla de oro ganando frente a Corea en la final por 45-35. Francia venci\xF3 a Espa\xF1a en la ronda de semifinales por 45-34, mientras que Corea venci\xF3 a Rusia por 45-39. La medalla de bronce fue para Rusia despu\xE9s de vencer a Espa\xF1a por 45-43.</p>\n        <p>La clasificaci\xF3n final de sable masculino individual estuvo compuesta por Sandro Bazadze (GEO, oro), Kamil Ibragimov (RUS, plata), Bolade Apithy (FRA, bronce), Junghwan Kim (KOR, bronce), Sanguk Oh (KOR), Andras Szatmari (HUN), Andrew Mackiewicz (USA) y Giovanni Repetti (ITA).</p>\n        <p>La clasificaci\xF3n final de sable femenino individual estuvo compuesta por Caroline Queroli (FRA, oro), Theodora Gkountoura (GRE, plata), Yana Egorian (RUS, bronce), Rossella Gregorio (ITA, bronce), Manon Apithy-Brunet (FRA), Svetlana Sheveleva (RUS), Sara Balzer (FRA) y Seri Ozaki (JPN).</p>\n        <p>La clasificaci\xF3n final de sable masculino por equipos estuvo liderada por Corea (oro), Alemania (plata), Rusia (bronce), Italia, Ir\xE1n, Egipto, Hungr\xEDa y Francia.</p>\n        <p>La clasificaci\xF3n final de sable femenino por equipos estuvo liderada por Francia (oro), Corea (plata), Rusia (bronce), Espa\xF1a, Italia, Bulgaria, Hungr\xEDa y Polonia.</p>\n        <p>Puede consultar todos los resultados oficiales del evento aqu\xED, en la p\xE1gina web de la FIE. Para acceder a m\xE1s noticias y art\xEDculos emocionantes de la esgrima a nivel mundial, vea el Canal de esgrima de la FIE en YouTube.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg27Anim = new TimelineMax();\n          pg27Anim\n            .fromTo(cOf(\"27-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"27-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"27-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"27-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg27Anim.stop();\n          resetNumbers(\"27-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "DEP ORTE  BAZADZE, QUEROLI, Y LOS EQUIPOS DE COREA Y FRANCIA GANAN EL ORO EN LA COPA DEL MUNDO DE SABLE TBILISI, GEORGIA 14-18 DE ENERO DE 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/es/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/es/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"28-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-edge-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg28Anim = new TimelineMax();\n          pg28Anim\n            .fromTo(idOf(\"28-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg28Anim.stop();\n          resetNumbers(\"28-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "COPA DEL MUNDO DE SABLE TBILISI, GEORGIA 2/3  Sandro Bazadze de Georgia y Caroline Queroli de Francia obtuvieron las medallas de oro individuales, ganando Corea y Francia las competiciones masculinas y femeninas por equipos en la Copa del mundo de sable en Tbilisi. En el evento, que se celebró en el Palacio Olímpico, compitieron 188 hombres y 154 mujeres, así como 24 equipos masculinos y 25 equipos femeninos. Bazadze se enfrentó al ruso Kamil Ibragimov en el encuentro final de sable masculino individual, al que ganó con una puntuación de 15-8. Ibragimov venció al campeón mundial coreano Junghwan Kim en la ronda de semifinales por 15-12, mientras que Bazadze ganó frente al francés Bolade Apithy, por 15-10. Apithy derrotó al campeón mundial coreano Sanguk Oh en los cuartos de final por 15-8, y Kim ganó al campeón mundial húngaro Andras Szatmari en la misma ronda por 15-12. Queroli ganó frente a la griega Theodora Gkountoura en el encuentro final de sable femenino individual por 15-12. Gkountoura venció a la campeona olímpica rusa Yana  Egorian en semifinales por 15-14, mientras que Queroli derrotó a la italiana Rossella Gregorio por 15-14. En sable masculino por equipos, Corea ganó frente a Alemania en el encuentro final por 45-38. Alemania venció a Italia en la ronda de semifinales por 45-43, mientras que Corea venció a Rusia por 45-44. La medalla de bronce fue para Rusia después de ganar a Italia por 45-40."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/es/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/es/static/_content/fb-red.png\">\n        </a>\n\n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"bottom: 201px; right: 153px; width: 279px; height: 20px;\"></div>\n        </a> \n        \n        <a href=\"https://www.youtube.com/c/FIEvideo\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"bottom: 131px; right: 166px; width: 310px; height: 20px;\"></div>\n        </a>\n\n        <img id=\"29-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg29Anim = new TimelineMax();\n          pg29Anim\n            .fromTo(idOf(\"29-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg29Anim.stop();\n          resetNumbers(\"29-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "COPA DEL MUNDO DE SABLE TBILISI, GEORGIA 3/3  En sable femenino por equipos, Francia consiguió la medalla de oro ganando frente a Corea en la final por 45-35. Francia venció a España en la ronda de semifinales por 45-34, mientras que Corea venció a Rusia por 45-39. La medalla de bronce fue para Rusia después de vencer a España por 45-43. La clasificación final de sable masculino individual estuvo compuesta por Sandro Bazadze (GEO, oro), Kamil Ibragimov (RUS, plata), Bolade Apithy (FRA, bronce), Junghwan Kim (KOR, bronce), Sanguk Oh (KOR), Andras Szatmari (HUN), Andrew Mackiewicz (USA) y Giovanni Repetti (ITA). La clasificación final de sable femenino individual estuvo compuesta por Caroline Queroli (FRA, oro), Theodora Gkountoura (GRE, plata), Yana Egorian (RUS, bronce), Rossella Gregorio (ITA, bronce), Manon Apithy-Brunet (FRA), Svetlana Sheveleva (RUS), Sara Balzer (FRA) y Seri Ozaki (JPN). La clasificación final de sable masculino por equipos estuvo liderada por Corea (oro),  Alemania (plata), Rusia (bronce), Italia, Irán, Egipto, Hungría y Francia. La clasificación final de sable femenino por equipos estuvo liderada por Francia (oro), Corea (plata), Rusia (bronce), España, Italia, Bulgaria, Hungría y Polonia. Puede consultar todos los resultados oficiales del evento aquí, en la página web de la FIE. Para acceder a más noticias y artículos emocionantes de la esgrima a nivel mundial, vea el Canal de esgrima de la FIE en YouTube. ■  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.facebook.com/uhlmann.fencing/\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 39px; right: 1095px; width: 19px; height: 18px;\"></div>\n        </a>\n        <a href=\"https://www.instagram.com/uhlmann.fencing/\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 39px; right: 1074px; width: 19px; height: 18px;\"></div>\n        </a>\n        <a href=\"https://uhlmann-fechtsport.com/en/\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 39px; right: 966px; width: 104px; height: 18px;\"></div>\n        </a>\n      ",
    "mobileHtml": "\n        <a href=\"https://uhlmann-fechtsport.com/en/\" target=\"_blank\">\n          <img src=\"/120/es/static/_content/30-mobile-1.jpg\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 31-title\" style=\"top:65px;left:64px;\" src=\"/120/es/static/_content/31-title-1.png\">\n        <img class=\"abs halfScale 31-sub\" style=\"top:148px;left:621px;\" src=\"/120/es/static/_content/31-sub-1.png\">\n        <img class=\"abs halfScale 31-line\" style=\"top:145px;left:588px;\" src=\"/120/es/static/_content/31-line-1.png\">\n        <img id=\"31-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2 id=\"azerbaijans-bashta-team-france-win-gold-at-women-s-sabre-world-cup\">\n          Bashta y el equipo de Francia ganan el oro en la Copa del mundo de sable femenino en Plovdiv</h2>\n        <img src=\"/120/es/static/_content/31-mobile-1.jpg\">\n        <p><strong>Plovdiv, Bulgaria<br>28-30 de enero de 2022</strong></p>\n        <p><strong>Anna Bashta de Azerbaiy\xE1n y el equipo de Francia obtienen las medallas de oro en la Copa del mundo de sable femenino en Plovdiv, Bulgaria. </strong></p>\n        <p>En el evento, que se celebr\xF3 en el Complex SILA, participaron 136 mujeres esgrimistas de sable y 20 equipos.</p>\n        <p>Bashta se enfrent\xF3 a la francesa Manon Apithy-Brunet en la ronda final de la prueba individual, ganando con una puntuaci\xF3n de 15-10. Apithy-Brunet venci\xF3 a su compa\xF1era de equipo, Malina Vongsavady, en semifinales por 15-9 y Bashta derrot\xF3 a la italiana Rossella Gregorio por 15-13.</p>\n        <p>En la competici\xF3n de sable femenino por equipos, Francia derrot\xF3 a Azerbaiy\xE1n en el encuentro final por 45-39. Azerbaiy\xE1n gan\xF3 frente a Bulgaria en semifinales por 45-32, y Francia venci\xF3 a Italia por 45-23. Italia gan\xF3 la medalla de bronce frente a Bulgaria por 45-29.</p>\n        <p>La clasificaci\xF3n de sable femenino individual estuvo compuesta por Anna Bashta (AZE, oro), Manon Apithy-Brunet (FRA, plata), Rossella Gregorio (ITA, bronce), Malina Vongsavady (FRA, bronce), Liza Pusztai (HUN), Misaki Emura (JPN), Olga Nikitina (RUS) y Svetlana Sheveleva (RUS).</p>\n        <p>La clasificaci\xF3n de sable femenino por equipos estuvo liderada por Francia (oro), Azerbaiy\xE1n (plata), Italia (bronce), Bulgaria, Hungr\xEDa, Espa\xF1a, Turqu\xEDa y Alemania.</p>\n        <p>Puede consultar todos los resultados oficiales del evento aqu\xED, en la p\xE1gina web de la FIE. Para acceder a m\xE1s noticias y art\xEDculos emocionantes de la esgrima a nivel mundial, vea el Canal de esgrima de la FIE en YouTube.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg31Anim = new TimelineMax();\n          pg31Anim\n            .fromTo(cOf(\"31-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"31-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"31-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"31-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg31Anim.stop();\n          resetNumbers(\"31-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "DEP ORTE  BASHTA Y EL EQUIPO DE FRANCIA GANAN EL ORO EN LA COPA DEL MUNDO DE SABLE PLOVDIV, BULGARIA FEMENINO EN PLOVDIV 28-30 DE ENERO DE 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/es/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/es/static/_content/fb-red.png\">\n        </a>\n\n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"  bottom: 130px; right: 193px; width: 207px; height: 20px;\"></div>\n        </a>\n        \n        <a href=\"https://www.youtube.com/c/FIEvideo\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"  bottom: 84px; right: 150px; width: 77px; height: 20px;\"></div>\n          <div class=\"addContentLink\"\n            style=\"  bottom: 59px; right: 282px; width: 243px; height: 22px;\"></div>\n        </a>\n\n        <img id=\"32-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg32Anim = new TimelineMax();\n          pg32Anim\n            .fromTo(idOf(\"32-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg32Anim.stop();\n          resetNumbers(\"32-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "COPA DEL MUNDO DE SABLE FEMENINO PLOVDIV, BULGARIA 2/2  Anna Bashta de Azerbaiyán y el equipo de Francia obtienen las medallas de oro en la Copa del mundo de sable femenino en Plovdiv, Bulgaria. En el evento, que se celebró en el Complex SILA, participaron 136 mujeres esgrimistas de sable y 20 equipos. Bashta se enfrentó a la francesa Manon Apithy-Brunet en la ronda final de la prueba individual, ganando con una puntuación de 15-10. Apithy-Brunet venció a su compañera de equipo, Malina Vongsavady, en semifinales por 15-9 y Bashta derrotó a la italiana Rossella Gregorio por 15-13. En la competición de sable femenino por equipos, Francia derrotó a Azerbaiyán en el encuentro final por 45-39. Azerbaiyán ganó frente a Bulgaria en semifinales por  45-32, y Francia venció a Italia por 45-23. Italia ganó la medalla de bronce frente a Bulgaria por 45-29. La clasificación de sable femenino individual estuvo compuesta por Anna Bashta (AZE, oro), Manon Apithy-Brunet (FRA, plata), Rossella Gregorio (ITA, bronce), Malina Vongsavady (FRA, bronce), Liza Pusztai (HUN), Misaki Emura (JPN), Olga Nikitina (RUS) y Svetlana Sheveleva (RUS). La clasificación de sable femenino por equipos estuvo liderada por Francia (oro), Azerbaiyán (plata), Italia (bronce), Bulgaria, Hungría, España, Turquía y Alemania. Puede consultar todos los resultados oficiales del evento aquí, en la página web de la FIE. Para acceder a más noticias y artículos emocionantes de la esgrima a nivel mundial, vea el Canal de esgrima de la FIE en YouTube. ■ W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 33-title\" style=\"top:65px;left:395px;\" src=\"/120/es/static/_content/33-title-1.png\">\n        <img class=\"abs halfScale 33-sub\" style=\"top:264px;left:426px;\" src=\"/120/es/static/_content/33-sub-1.png\">\n        <img class=\"abs halfScale 33-line\" style=\"top:263px;left:394px;\" src=\"/120/es/static/_content/33-line-1.png\">\n        <img id=\"33-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2 id=\"france-s-borel-estonia-s-lehis-win-qatar-epee-grand-prix\">Borel de Francia y Lehis de Estonia ganan los Grandes Premios de espada de Qatar</h2>\n        <img src=\"/120/es/static/_content/33-mobile-1.jpg\">\n        <p><strong>Doha, Qatar<br>28-30 de enero de 2022</strong></p>\n        <p><strong>El campe\xF3n del mundo de Francia, Yannick Borel, y Katrina Lehis de Estonia obtuvieron medallas de oro individuales en los Grandes Premios de espada de 2022 en Doha, Qatar. </strong></p>\n        <p>En el evento, que se celebr\xF3 en el complejo deportivo Aspire Zone/Aspire Dome, compitieron 161 hombres y 120 mujeres.</p>\n        <p>En el encuentro final de espada masculina individual, Borel se enfrent\xF3 al compa\xF1ero de equipo Aymerick Gally, al que gan\xF3 con una puntuaci\xF3n de 15-10. Gally venci\xF3 al italiano Federico Vismara en las semifinales por 15-6, y Borel derrot\xF3 al italiano Davide Di Veroli por 15-9. Cabe destacar que el campe\xF3n ol\xEDmpico franc\xE9s Romain Cannone perdi\xF3 en cuartos de final frente a Borel, por 15-5, y el campe\xF3n del mundo h\xFAngaro Gergely Siklosi perdi\xF3 frente a Di Veroli en la ronda 16 por 15-12.</p>\n        <p>En espada femenina individual, Lehis gan\xF3 la ronda final frente a su compa\xF1era de equipo Nelli Differt, por 15-11. Differt venci\xF3 a otra compa\xF1era de equipo, Erika Kirpu, en la ronda de semifinales por 12-11, y Lehis gan\xF3 frente a la francesa Marie-Florence Candassamy por 15-14. Cabe destacar que Candassamy venci\xF3 a la campeona ol\xEDmpica ucraniana Yana Shemyakina en cuartos de final por 15-9.</p>\n        <p>La clasificaci\xF3n final de espada masculina estuvo compuesta por Yannick Borel (FRA, oro), Aymerick Gally (FRA, plata), Davide Di Veroli (ITA, bronce), Federico Vismara (ITA, bronce), Igor Reizlin (UKR), Romain Cannone (FRA), Alexandre Bardenet (FRA) y Volodymyr Stankevych (UKR).</p>\n        <p>La clasificaci\xF3n final de espada femenina estuvo compuesta por Katrina Lehis (EST, oro), Nelli Differt (EST, plata), Marie-Florence Candassamy (FRA, bronce), Erika Kirpu (EST, bronce), Renata Knapik-Miazga (POL), Irina Embrich (EST), Anna Kun (HUN) y Yana Shemyakina (UKR).</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg33Anim = new TimelineMax();\n          pg33Anim\n            .fromTo(cOf(\"33-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"33-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"33-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"33-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg33Anim.stop();\n          resetNumbers(\"33-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "DEP ORTE  BOREL DE FRANCIA Y LEHIS DE ESTONIA GANAN LOS GRANDES PREMIOS DE ESPADA DE QATAR DOHA, QATAR 28-30 DE ENERO DE 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/es/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/es/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"34-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg34Anim = new TimelineMax();\n          pg34Anim\n            .fromTo(idOf(\"34-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg34Anim.stop();\n          resetNumbers(\"34-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "GRANDES PREMIOS DE ESPADA DOHA, QATAR 2/2  El campeón del mundo de Francia, Yannick Borel, y Katrina Lehis de Estonia obtuvieron medallas de oro individuales en los Grandes Premios de espada de 2022 en Doha, Qatar. En el evento, que se celebró en el complejo deportivo Aspire Zone/Aspire Dome, compitieron 161 hombres y 120 mujeres. En el encuentro final de espada masculina individual, Borel se enfrentó al compañero de equipo Aymerick Gally, al que ganó con una puntuación de 15-10. Gally venció al italiano Federico Vismara en las semifinales por 15-6, y Borel derrotó al italiano Davide Di Veroli por 15-9. Cabe destacar que el campeón olímpico francés Romain Cannone perdió en cuartos de final frente a Borel, por 15-5, y el campeón del mundo húngaro Gergely Siklosi perdió frente a Di Veroli en la ronda 16 por 15-12. En espada femenina individual, Lehis ganó la ronda final frente a su compañera de equipo Nelli Differt, por 15-11. Differt venció a otra compañera de equipo, Erika Kirpu, en la ronda de semifinales por 12-11, y Lehis ganó frente a la francesa Marie-Florence Candassamy  por 15-14. Cabe destacar que Candassamy venció a la campeona olímpica ucraniana Yana Shemyakina en cuartos de final por 15-9. La clasificación final de espada masculina estuvo compuesta por Yannick Borel (FRA, oro), Aymerick Gally (FRA, plata), Davide Di Veroli (ITA, bronce), Federico Vismara (ITA, bronce), Igor Reizlin (UKR), Romain Cannone (FRA), Alexandre Bardenet (FRA) y Volodymyr Stankevych (UKR). La clasificación final de espada femenina estuvo compuesta por Katrina Lehis (EST, oro), Nelli Differt (EST, plata), Marie-Florence Candassamy (FRA, bronce), Erika Kirpu (EST, bronce), Renata Knapik-Miazga (POL), Irina Embrich (EST), Anna Kun (HUN) y Yana Shemyakina (UKR). ■ W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 35-title\" style=\"top:88px;left:381px;\" src=\"/120/es/static/_content/35-title-1.png\">\n        <img class=\"abs halfScale 35-sub\" style=\"top:231px;left:410px;\" src=\"/120/es/static/_content/35-sub-1.png\">\n        <img class=\"abs halfScale 35-line\" style=\"top:234px;left:378px;\" src=\"/120/es/static/_content/35-line-1.png\">\n        <img id=\"35-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2 id=\"men-s-and-women-s-epee-grand-prix-in-budapest\">Gran Premio de espada masculina y femenina en Budapest</h2>\n        <img src=\"/120/es/static/_content/35-mobile-1.jpg\">\n        <p><strong>Budapest, Hungr\xEDa<br>4\u20136 Marzo 2022</strong></p>\n        <p><strong>El tricampe\xF3n ol\xEDmpico h\xFAngaro Aron Szilagyi gan\xF3 la medalla de oro individual y Hungr\xEDa se llev\xF3 la medalla de oro masculina por equipos en la Copa del mundo de sable masculino de Budapest.  </strong></p>\n        <p>Denominadas en concreto la Copa del mundo individual \xABGerevich-Kov\xE1cs-K\xE1rp\xE1ti\xBB y la Copa del mundo por equipos \xABZar\xE1ndi Csaba\xBB, el evento general incluy\xF3 la participaci\xF3n de 204 esgrimistas individuales y 23 equipos, y se celebr\xF3 en el City\u2019s BOK Hall (anteriormente, SYMA Hall). </p>\n        <p>Szilagyi se enfrent\xF3 al italiano Luca Curatoli en el encuentro final por la medalla de oro de la prueba de sable masculino individual, al que gan\xF3 con una puntuaci\xF3n de 15-7. En la ronda de semifinales, Curatoli venci\xF3 al campe\xF3n mundial coreano Sanguk Oh por 15-8, mientras que Szilagyi gan\xF3 frente al campe\xF3n mundial coreano Junghwan Kim, por 15-14.</p>\n        <p>En la prueba de sable masculino por equipos, Hungr\xEDa gan\xF3 la medalla de oro frente a Francia en la ronda final con una puntuaci\xF3n de 45-38. Francia venci\xF3 a Alemania en semifinales por 45-40, y Hungr\xEDa derrot\xF3 a Ruman\xEDa por 45-30. La medalla de bronce fue para Alemania despu\xE9s de ganar a Ruman\xEDa por 45-43. \n        </p>\n        <p>La clasificaci\xF3n final de sable masculino individual estuvo compuesta por Aron Szilagyi (HUN, oro), Luca Curatoli (ITA, plata), Junghwan Kim (KOR, bronce), Sanguk Oh (KOR, bronce), Bolade Apithy (FRA), Luigi Samele (ITA), Daryl Homer (USA) y Matyas Szabo (GER). </p>\n        <p>La clasificaci\xF3n final de sable masculino por equipos estuvo liderada por Hungr\xEDa (oro), Francia (plata), Alemania (bronce), Ruman\xEDa, Corea, EE. UU., Italia e Ir\xE1n.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg35Anim = new TimelineMax();\n          pg35Anim\n            .fromTo(cOf(\"35-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"35-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"35-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"35-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg35Anim.stop();\n          resetNumbers(\"35-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "DEP ORTE  GRAN PREMIO DE ESPADA MASCULINA Y FEMENINA EN BUDAPEST BUDAPEST, HUNGRÍA 4–6 MARZO 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/es/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/es/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"36-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-edge-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg36Anim = new TimelineMax();\n          pg36Anim\n            .fromTo(idOf(\"36-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg36Anim.stop();\n          resetNumbers(\"36-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "GRAN PREMIO DE ESPADA BUDAPEST, HUNGRÍA 2/3  El tricampeón olímpico húngaro Aron Szilagyi ganó la medalla de oro individual y Hungría se llevó la medalla de oro masculina por equipos en la Copa del mundo de sable masculino de Budapest. Denominadas en concreto la Copa del mundo individual «Gerevich-Kovács-Kárpáti» y la Copa del mundo por equipos «Zarándi Csaba», el evento general incluyó la participación de 204 esgrimistas individuales y 23 equipos, y se celebró en el City’s BOK Hall (anteriormente, SYMA Hall).  Szilagyi se enfrentó al italiano Luca Curatoli en el encuentro final por la medalla de oro de la prueba de sable masculino individual, al que ganó con una puntuación de 15-7. En la ronda de semifinales, Curatoli venció al campeón mundial coreano Sanguk Oh por 15-8, mientras que Szilagyi ganó frente al campeón mundial coreano Junghwan Kim, por 15-14. En la prueba de sable masculino por equipos, Hungría ganó la medalla de oro frente a Francia en la ronda final con una puntuación de 45-38. Francia venció a Alemania en semifinales por 45-40, y Hungría derrotó a Rumanía por 45-30. La medalla de bronce fue para Alemania después de ganar a Rumanía por 45-43."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/es/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/es/static/_content/fb-red.png\">\n        </a>\n\n        <!-- <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"  bottom: 624px; right: 156px; width: 114px; height: 20px; \"></div>\n        </a> -->\n        \n        <a href=\"https://www.youtube.com/c/FIEvideo\" target=\"_blank\">\n          <div class=\"addContentLink\"\n            style=\"bottom: 577px; right: 152px; width: 111px; height: 20px;\"></div>\n          <div class=\"addContentLink\"\n            style=\"bottom: 554px; right: 388px; width: 139px; height: 20px;\"></div>\n        </a>\n\n        <img id=\"37-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg37Anim = new TimelineMax();\n          pg37Anim\n            .fromTo(idOf(\"37-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg37Anim.stop();\n          resetNumbers(\"37-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "GRAN PREMIO DE ESPADA BUDAPEST, HUNGRÍA 3/3  La clasificación final de sable masculino individual estuvo compuesta por Aron Szilagyi (HUN, oro), Luca Curatoli (ITA, plata), Junghwan Kim (KOR, bronce), Sanguk Oh (KOR, bronce), Bolade Apithy (FRA), Luigi Samele (ITA), Daryl Homer (USA) y Matyas Szabo (GER).  La clasificación final de sable masculino por equipos estuvo liderada por Hungría (oro), Francia (plata), Alemania (bronce), Rumanía, Corea, EE. UU., Italia e Irán. ■  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "",
    "mobileHtml": "\n        <img src=\"/120/es/static/_content/38-mobile-1.jpg\">\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 39-title\" style=\"top:75px;left:64px;\" src=\"/120/es/static/_content/39-title-1.png\">\n        <img class=\"abs halfScale 39-sub\" style=\"top:220px;left:97px;\" src=\"/120/es/static/_content/39-sub-1.png\">\n        <img class=\"abs halfScale 39-line\" style=\"top:223px;left:64px;\" src=\"/120/es/static/_content/39-line-1.png\">\n        <img id=\"39-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-edge-red.png\">\n      ",
    "mobileHtml": "\n        <h2\n          id=\"a-grand-and-successful-2022-junior-and-cadet-fencing-world-championships-in-dubai\">\n          Grandes y exitosos Campeonatos del mundo de Esgrima juniors y cadetes de 2022 en Dub\xE1i </h2>\n        <img src=\"/120/es/static/_content/39-mobile-1.jpg\">\n        <p><strong>DUB\xC1I, Emiratos \xC1rabes Unidos<br>2-10 de abril de 2022</strong></p>\n        <p><strong>El Presidente interino de la FIE, Emmanuel Katsiadakis, ha declarado que los Campeonatos del mundo de Esgrima juniors y cadetes de 2022 han sido un gran \xE9xito.</strong></p>\n        <p>La prueba del noveno d\xEDa, que incluy\xF3 18 pruebas individuales y por equipos de esgrimistas masculinos y femeninos juniors y cadetes, cont\xF3 con el mayor n\xFAmero de participantes de su historia, con 1357 esgrimistas procedentes de 103 pa\xEDses. Las pruebas se celebraron en el impresionante Complejo Deportivo Hamdan de Dub\xE1i, un centro deportivo multifuncional de clase mundial conocido por albergar una amplia gama de campeonatos y pruebas internacionales.  </p>\n        <p>A continuaci\xF3n, se muestran por continentes los pa\xEDses participantes en los Campeonatos del mundo de Esgrima juniors y cadetes:</p>\n        <ul>\n          <li>\n            \xC1frica 13</li>\n          <li>\n            Am\xE9rica 20</li>\n          <li>\n            Asia/Ocean\xEDa 32</li>\n          <li>\n            Europa 38</li>\n          <li>\n            Total 103 </li>\n          </ul>\n          <p>La ceremonia oficial de inauguraci\xF3n de los Campeonatos cont\xF3 con la\n            asistencia de varios dignatarios locales, incluido H.E. Dr. Ahmad bin Abdullah\n            Humaid Belhoul Al Falasi, Ministro de Estado de iniciativa empresarial y\n            PYMEs, adem\xE1s de Presidente de la Junta Directiva de la Autoridad General\n            Deportiva; H.E. Sheikh Salem bin Sultan Al Qasimi, miembro del Comit\xE9\n            Ejecutivo de la FIE, Presidente de la Confederaci\xF3n de Esgrima Asi\xE1tica,\n            Presidente de la Federaci\xF3n de Esgrima \xC1rabe y Presidente de la Federaci\xF3n de\n            Esgrima de los EAU; H.E. Saeed Hareb, Secretario General del Consejo de\n            Deportes de Dub\xE1i y H.E. Nasser Al Rahma, Vicepresidente del Complejo\n            Deportivo Hamdan. Los Campeonatos se declararon oficialmente inaugurados por\n            el Presidente interino de la FIE Emmanuel Katsiadakis. </p>\n          <p>Cada arma (sable, florete y espada) cont\xF3 con tres d\xEDas consecutivos de\n            competici\xF3n, y cada ciclo de tres d\xEDas incluy\xF3 un primer d\xEDa de pruebas\n            masculinas y femeninas individuales juniors, seguido de un d\xEDa de pruebas\n            individuales de cadetes y un d\xEDa final de pruebas juniors por equipos. </p>\n          <p>En los Campeonatos se siguieron los protocolos del COVID-19 para garantizar\n            la seguridad de todos los participantes y asistentes, incluyendo la\n            obligatoriedad de la mascarilla, la distancia social, as\xED como la realizaci\xF3n\n            de pruebas con frecuencia.\n            Las clasificaciones principales incluyeron los siguientes resultados:</p>\n          <p>Sable</p>\n          <ul>\n            <li>\n              Sable masculino individual juniors (152 esgrimistas)<ol>\n                <li>\n                  Colin Heathcock (GER, oro)</li>\n                <li>\n                  Pietro Torre (ITA, plata)</li>\n                <li>\n                  Antonio Heathcock (GER, bronce)</li>\n                <li>\n                  Heegeun Hwang (KOR, bronce)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              Sable femenino individual juniors (126 esgrimistas)<ol>\n                <li>\n                  Magda Skarbonkiewicz (USA, oro)</li>\n                <li>\n                  Honor Johnson (USA, plata)</li>\n                <li>\n                  Zaynab Dayibekova (UZB, bronce)</li>\n                <li>\n                  Sugar Katinka Battai (HUN, bronce)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              Sable masculino individual cadetes (95 esgrimistas)<ol>\n                <li>\n                  Zuhridden Kodirov (UZB, oro)</li>\n                <li>\n                  Colin Heathcock (GER, plata)</li>\n                <li>\n                  Cody Ji (USA, bronce)</li>\n                <li>\n                  William Morrill (USA, bronce)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              Sable femenino individual cadetes (90 esgrimistas)<ol>\n                <li>\n                  Magda Skarbonkiewicz (USA, oro)</li>\n                <li>\n                  Siobhan Sullivan (USA, plata)</li>\n                <li>\n                  Alejandra Manga (FRA, bronce)</li>\n                <li>\n                  Eunyu Kim (KOR, bronce)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              Sable masculino juniors por equipos (34 equipos)<ol>\n                <li>\n                  Italia (oro)</li>\n                <li>\n                  Ruman\xEDa (plata)</li>\n                <li>\n                  Egipto (bronce)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              Sable femenino juniors por equipos (27 equipos)<ol>\n                <li>\n                  Francia (oro)</li>\n                <li>\n                  Hungr\xEDa (plata)</li>\n                <li>\n                  Italia (bronce)</li>\n              </ol>\n            </li>\n          </ul>\n          <p>Florete</p>\n          <ul>\n            <li>\n              Florete masculino individual juniors (180 esgrimistas)<ol>\n                <li>\n                  Kazuki Iimura (JPN, oro)</li>\n                <li>\n                  Hyeonbhin An (KOR, plata)</li>\n                <li>\n                  Anas Anane (FRA, bronce)</li>\n                <li>\n                  Chase T. Emmer (USA, bronce)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              Florete femenino individual juniors (148 esgrimistas)<ol>\n                <li>\n                  Lauren Scruggs (USA, oro)</li>\n                <li>\n                  Yuzuha Takeyama (JPN, plata)</li>\n                <li>\n                  Carolina Stutchbury (GBR, bronce)</li>\n                <li>\n                  Kateryna Budenko (UKR, bronce)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              Florete masculino individual cadetes (117 esgrimistas)<ol>\n                <li>\n                  Tit Nam Cheng (HKG, oro)</li>\n                <li>\n                  Ruben Lindner (GER, plata)</li>\n                <li>\n                  Matteo Iacomoni (ITA, bronce)</li>\n                <li>\n                  Andrew Chen (USA, bronce)</li>\n              </ol>\n            </li>\n            <li>\n              Florete femenino individual cadetes (104 esgrimistas)<ol>\n                <li>\n                  Jessica Zi Jia Guo (CAN, oro)</li>\n                <li>\n                  Carolina Stutchbury (GBR, plata)</li>\n                <li>\n                  Rino Nagase (JPN, bronce)</li>\n                <li>\n                  Matilde Molinari (ITA, bronce)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              Florete masculino juniors por equipos (37 equipos)<ol>\n                <li>\n                  Italia (oro)</li>\n                <li>\n                  Francia (plata)</li>\n                <li>\n                  Hungr\xEDa (bronce)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              Florete femenino juniors por equipos (32 equipos)<ol>\n                <li>\n                  USA (oro)</li>\n                <li>\n                  Italia (plata)</li>\n                <li>\n                  Jap\xF3n (bronce)</li>\n              </ol>\n            </li>\n          </ul>\n          <p>Espada </p>\n          <ul>\n            <li>\n              Espada masculina individual juniors (208 esgrimistas)<ol>\n                <li>\n                  Zsombor Keszthelyi (HUN, oro)</li>\n                <li>\n                  Mohamed Yasseen (EGY, plata)</li>\n                <li>\n                  James Jeal (GBR, bronce)</li>\n                <li>\n                  Lino Heurlin Vazquez (FRA, bronce)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              Espada femenina individual juniors (160 esgrimistas)<ol>\n                <li>\n                  Hadley Husisian (USA, oro)</li>\n                <li>\n                  Nicole Feygin (ISR, plata)</li>\n                <li>\n                  Aleyna Erturk (TUR, bronce)</li>\n                <li>\n                  Ketki Ketkar (USA, bronce)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              Espada masculina individual cadetes (142 esgrimistas)<ol>\n                <li>\n                  Samuel Imrek (USA, oro)</li>\n                <li>\n                  Alon Sarid (ISR, plata)</li>\n                <li>\n                  Fabio Mastromarino (ITA, bronce)</li>\n                <li>\n                  Maksym Perchuk (UKR, bronce)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              Espada femenina individual cadetes (109 esgrimistas)<ol>\n                <li>\n                  Aleyna Erturk (TUR, oro)</li>\n                <li>\n                  Anna Maksymenko (UKR, plata)</li>\n                <li>\n                  Hailin Chen (HKG, bronce)</li>\n                <li>\n                  Mizuki Homma (JPN, bronce)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              Espada masculina juniors por equipos (42 equipos)<ol>\n                <li>\n                  Egipto (oro)</li>\n                <li>\n                  EE. UU. (plata)</li>\n                <li>\n                  Francia (bronce)</li>\n              </ol>\n            </li>\n          </ul>\n          <ul>\n            <li>\n              Espada femenina juniors por equipos (33 equipos)<ol>\n                <li>\n                  Israel (oro)</li>\n                <li>\n                  Polonia (plata)</li>\n                <li>\n                  EE. UU. (bronce)</li>\n              </ol>\n            </li>\n          </ul>\n          <p>Haga clic aqu\xED para ver los MEDALLISTAS [POP UP]</p>\n          <p>Tablero completo de medallas</p>\n          <ol>\n            <li>\n              USA - 6 Gold, 3 Silver, 6 Bronze - 15 Total</li>\n            <li>\n              ITA - 2 Gold, 2 Silver, 4 Bronze - 8 Total</li>\n            <li>\n              GER - 1 Gold, 2 Silver, 1 Bronze - 4 Total</li>\n            <li>\n              ISR - 1 Gold, 2 Silver, 0 Bronze - 3 Total</li>\n            <li>\n              FRA - 1 Gold, 1 Silver, 4 Bronze - 6 Total</li>\n            <li>\n              JPN - 1 Gold, 1 Silver, 3 Bronze - 5 Total</li>\n            <li>\n              HUN - 1 Gold, 1 Silver, 2 Bronze - 4 Total</li>\n            <li>\n              EGY - 1 Gold, 1 Silver, 1 Bronze - 3 Total</li>\n            <li>\n              TUR - 1 Gold, 0 Silver, 1 Bronze - 2 Total</li>\n            <li>\n              HKG - 1 Gold, 0 Silver, 1 Bronze - 2 Total</li>\n            <li>\n              UZB - 1 Gold, 0 Silver, 1 Bronze - 2 Total</li>\n            <li>\n              CAN - 1 Gold, 0 Silver, 0 Bronze - 1 Total</li>\n            <li>\n              UKR - 0 Gold, 1 Silver, 2 Bronze - 3 Total</li>\n            <li>\n              GBR - 0 Gold, 1 Silver, 2 Bronze - 3 Total</li>\n            <li>\n              KOR - 0 Gold, 1 Silver, 2 Bronze - 3 Total</li>\n            <li>\n              POL - 0 Gold, 1 Silver, 0 Bronze - 1 Total</li>\n            <li>\n              ROU - 0 Gold, 1 Silver, 0 Bronze - 1 Total</li>\n          </ol>\n      ",
    "script": "\n        function onPageEnter() {\n          pg39Anim = new TimelineMax();\n          pg39Anim\n            .fromTo(cOf(\"39-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"39-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"39-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"39-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg39Anim.stop();\n          resetNumbers(\"39-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "DEP ORTE  GRANDES Y EXITOSOS CAMPEONATOS DEL MUNDO DE ESGRIMA JUNIORS Y CADETES DE 2022 EN DUBÁI DUBÁI, EMIRATOS ÁRABES UNIDOS 2-10 DE ABRIL DE 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/es/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/es/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"40-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-edge-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg40Anim = new TimelineMax();\n          pg40Anim\n            .fromTo(idOf(\"40-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg40Anim.stop();\n          resetNumbers(\"40-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "CAMPEONATOS DEL MUNDO DE ESGRIMA JUNIORS Y CADETES DUBÁI, EMIRATOS ÁRABES UNIDOS 2/5  El Presidente interino de la FIE, Emmanuel Katsiadakis, ha declarado que los Campeonatos del mundo de Esgrima juniors y cadetes de 2022 han sido un gran éxito. La prueba del noveno día, que incluyó 18 pruebas individuales y por equipos de esgrimistas masculinos y femeninos juniors y cadetes, contó con el mayor número de participantes de su historia, con 1357 esgrimistas procedentes de 103 países. Las pruebas se celebraron en el impresionante Complejo Deportivo Hamdan de Dubái, un centro deportivo multifuncional de clase mundial conocido por albergar una amplia gama de campeonatos y pruebas internacionales.  A continuación, se muestran por continentes los países participantes en los Campeonatos del mundo de Esgrima juniors y cadetes: África			13 América			20 Asia/Oceanía		 32 Europa			38 Total			103 La ceremonia oficial de inauguración de los Campeonatos contó con la asistencia de varios dignatarios locales, incluido H.E. Dr. Ahmad bin Abdullah Humaid Belhoul Al Falasi, Ministro de Estado de iniciativa empresarial y PYMEs, además de Presidente de la Junta Directiva de la Autoridad General Deportiva; H.E. Sheikh Salem bin Sultan Al Qasimi, miembro"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/es/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/es/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"41-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-edge-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg41Anim = new TimelineMax();\n          pg41Anim\n            .fromTo(idOf(\"41-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg41Anim.stop();\n          resetNumbers(\"41-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "CAMPEONATOS DEL MUNDO DE ESGRIMA JUNIORS Y CADETES DUBÁI, EMIRATOS ÁRABES UNIDOS 3/5  del Comité Ejecutivo de la FIE, Presidente de la Confederación de Esgrima Asiática, Presidente de la Federación de Esgrima Árabe y Presidente de la Federación de Esgrima de los EAU; H.E. Saeed Hareb, Secretario General del Consejo de Deportes de Dubái y H.E. Nasser Al Rahma, Vicepresidente del Complejo Deportivo Hamdan. Los Campeonatos se declararon oficialmente inaugurados por el Presidente interino de la FIE Emmanuel Katsiadakis. Cada arma (sable, florete y espada) contó con tres días consecutivos de competición, y cada ciclo de tres días incluyó un primer día de pruebas masculinas y femeninas individuales juniors, seguido de un día de pruebas individuales de cadetes y un día final de pruebas juniors por equipos. En los Campeonatos se siguieron los protocolos del COVID-19 para garantizar la seguridad de todos los participantes y asistentes, incluyendo la obligatoriedad de la mascarilla, la distancia social, así como la realización de pruebas con frecuencia. Las clasificaciones principales incluyeron los siguientes resultados:  SABLE • Sable masculino individual juniors (152 esgrimistas) 1. Colin Heathcock (GER, oro) 2. Pietro Torre (ITA, plata) 3. Antonio Heathcock (GER, bronce) 3. Heegeun Hwang (KOR, bronce) • Sable femenino individual juniors (126 esgrimistas) 1. Magda Skarbonkiewicz (USA, oro) 2. Honor Johnson (USA, plata) 3. Zaynab Dayibekova (UZB, bronce) 3. Sugar Katinka Battai (HUN, bronce) • Sable masculino individual cadetes (95 esgrimistas) 1. Zuhridden Kodirov (UZB, oro) 2. Colin Heathcock (GER, plata) 3. Cody Ji (USA, bronce) 3. William Morrill (USA, bronce)"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/es/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/es/static/_content/fb-red.png\">\n        </a>\n\n        <img id=\"42-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-edge-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg42Anim = new TimelineMax();\n          pg42Anim\n            .fromTo(idOf(\"42-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg42Anim.stop();\n          resetNumbers(\"42-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "CAMPEONATOS DEL MUNDO DE ESGRIMA JUNIORS Y CADETES DUBÁI, EMIRATOS ÁRABES UNIDOS 4/5  FLORETE • Florete masculino individual juniors (180 esgrimistas) 1. Kazuki Iimura (JPN, oro) 2. Hyeonbhin An (KOR, plata) 3. Anas Anane (FRA, bronce) 3. Chase T. Emmer (USA, bronce)  • Sable femenino individual cadetes (90 esgrimistas) 1. Magda Skarbonkiewicz (USA, oro) 2. Siobhan Sullivan (USA, plata) 3. Alejandra Manga (FRA, bronce) 3. Eunyu Kim (KOR, bronce) • Sable masculino juniors por equipos (34 equipos) 1. Italia (oro) 2. Rumanía (plata) 3. Egipto (bronce) • Sable femenino juniors por equipos (27 equipos) 1. Francia (oro) 2. Hungría (plata) 3. Italia (bronce)  • Florete femenino individual juniors (148 esgrimistas) 1. Lauren Scruggs (USA, oro) 2. Yuzuha Takeyama (JPN, plata) 3. Carolina Stutchbury (GBR, bronce) 3. Kateryna Budenko (UKR, bronce) • Florete masculino individual cadetes (117 esgrimistas) 1. Tit Nam Cheng (HKG, oro) 2. Ruben Lindner (GER, plata) 3. Matteo Iacomoni (ITA, bronce) 3. Andrew Chen (USA, bronce) • Florete femenino individual cadetes (104 esgrimistas) 1. Jessica Zi Jia Guo (CAN, oro) 2. Carolina Stutchbury (GBR, plata) 3. Rino Nagase (JPN, bronce) 3. Matilde Molinari (ITA, bronce)"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/es/static/_content/tw-red.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/es/static/_content/fb-red.png\">\n        </a>\n          \n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:655px;left:45px\" onclick=\"showOverlay('43-popups')\"\n          src=\"/120/es/static/_content/trophy-red.png\">\n        \n        <img id=\"43-next\" class=\"halfScale pointer\" style=\"top:647px;right:-92px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-pad-red.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n\n        <div id=\"43-popups\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img src=\"/120/es/static/_content/39-popup-1.png\" style=\"transform: scale(0.873); transform-origin: top left;\">\n          <div class=\"contentLink\" style=\"top: 55px; left: 1025px; width: 35px; height: 35px;\" onclick=\"hideOverlay('43-popups');\"></div>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg43Anim = new TimelineMax();\n          pg43Anim\n            .fromTo(idOf(\"43-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg43Anim.stop();\n          resetNumbers(\"43-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "CAMPEONATOS DEL MUNDO DE ESGRIMA JUNIORS Y CADETES DUBÁI, EMIRATOS ÁRABES UNIDOS 5/5  • Florete masculino juniors por equipos (37 equipos) 1. Italia (oro) 2. Francia (plata) 3. Hungría (bronce) • Florete femenino juniors por equipos (32 equipos) 1. USA (oro) 2. Italia (plata) 3. Japón (bronce) ESPADA • Espada masculina individual juniors (208 esgrimistas) 1. Zsombor Keszthelyi (HUN, oro) 2. Mohamed Yasseen (EGY, plata) 3. James Jeal (GBR, bronce) 3. Lino Heurlin Vazquez (FRA, bronce)  Haga clic aquí para ver los MEDALLISTAS  • Espada femenina individual juniors (160 esgrimistas) 1. Hadley Husisian (USA, oro) 2. Nicole Feygin (ISR, plata) 3. Aleyna Erturk (TUR, bronce) 3. Ketki Ketkar (USA, bronce)  • Espada masculina individual cadetes (142 esgrimistas) 1. Samuel Imrek (USA, oro) 2. Alon Sarid (ISR, plata) 3. Fabio Mastromarino (ITA, bronce) 3. Maksym Perchuk (UKR, bronce) • Espada femenina individual cadetes (109 esgrimistas) 1. Aleyna Erturk (TUR, oro) 2. Anna Maksymenko (UKR, plata) 3. Hailin Chen (HKG, bronce) 3. Mizuki Homma (JPN, bronce) • Espada masculina juniors por equipos (42 equipos) 1. Egipto (oro) 2. EE. UU. (plata) 3. Francia (bronce) • Espada femenina juniors por equipos (33 equipos) 1. Israel (oro) 2. Polonia (plata) 3. EE. UU. (bronce) ■ W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "\n        <a href=\"mailto:service@blue-gauntletservice.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 277px; right: 647px; width: 175px; height: 21px;\"></div>\n        </a>\n        <!-- <a href=\"mailto:service@blue-gauntletservice.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 201px; right: 697px; width: 265px; height: 21px;\"></div>\n        </a> -->\n        <a href=\"https://www.blue-gauntlet.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 255px; right: 685px; width: 135px; height: 21px;\"></div>\n        </a>\n        <!-- <a href=\"https://www.blue-gauntlet.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 157px; right: 751px; width: 209px; height: 38px;\"></div>\n        </a> -->\n      ",
    "mobileHtml": "\n        <a href=\"https://www.blue-gauntlet.com\" target=\"_blank\">\n          <img src=\"/120/es/static/_content/44-mobile-1.jpg\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 45-title\" style=\"top:58px;left:65px;\" src=\"/120/es/static/_content/45-title-1.png\">\n\n        <img id=\"45-next\" class=\"halfScale pointer\" style=\"top:718px;right:-243px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-long-pink.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n        \n        <div class=\"contentLink\" onclick=\"showOverlay('45-popups')\" style=\"bottom: 397px; right: 141px; width: 58px; height: 33px;\"></div>\n\n        <div id=\"45-popups\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img id=\"45-pop-1\" class=\"halfScale 45-popup\" src=\"/120/es/static/_content/45-popup-1.png\" alt=\"\">\n          <img id=\"45-pop-2\" class=\"halfScale 45-popup\" src=\"/120/es/static/_content/45-popup-2.png\" style=\"opacity:0\" alt=\"\">\n          <div class=\"contentLink\" style=\"top:721px;left:600px;width:138px;height:48px;\"\n            onclick=\"togglePage45('45-pop-1', '45-popup');\"></div>\n          <div class=\"contentLink\" style=\"top:721px;left:738px;width:138px;height:48px;\"\n            onclick=\"togglePage45('45-pop-2', '45-popup');\"></div>\n          <div class=\"contentLink\" style=\"top: 40px; left: 1016px; width: 35px; height: 35px;\"\n            onclick=\"hideOverlay('45-popups');\"></div>\n        </div>\n      ",
    "mobileHtml": "\n        <h2\n          id=\"bert-m-j-van-de-flier-ned-mh-given-royal-decoration-from-the-netherlands\">\n          Bert M.J. van de Flier (NED, MH) recibi\xF3 la condecoraci\xF3n real de los Pa\xEDses Bajos\n        </h2>\n        <img src=\"/120/es/static/_content/45-mobile-1.jpg\">\n        <p><strong> Lausana, Suiza<br>6 de diciembre de 2021</strong></p>\n        <p><strong>Se ha comunicado a la FIE que el Miembro de Honor de la FIE y Miembro del Consejo de Juego Limpio de la FIE Bert M. J. van de Flier (NED) ha recibido la condecoraci\xF3n \xABResponsable de la Orden de Orange-Nassau\xBB por parte de su Excelencia Pieter de Gooijer, embajador de los Pa\xEDses Bajos en Francia. El acto se celebr\xF3 en presencia del Sr. Dominique Breton, c\xF3nsul honorario de Brest; el Sr. Guy Pennec, alcalde de Plourin-les-Morlaix; y Leon Pijnappel, presidente de la Federaci\xF3n Neerlandesa de Esgrima (KNAS). </strong></p>\n        <p>La condecoraci\xF3n supera el t\xEDtulo de caballero, uno de los premios m\xE1s importantes que se le puede conceder a un civil de los Pa\xEDses Bajos, y que se le otorga en reconocimiento a sus numerosos a\xF1os de servicio y dedicaci\xF3n a la esgrima neerlandesa, europea y mundial. A lo largo de muchos a\xF1os, el Sr. van de Flier ha desempe\xF1ado muchas funciones y ha obtenido numerosos logros que han conducido a este premio:</p>\n        <p>El Sr. van de Flier fue nombrado Miembro de Honor de la FIE en el Congreso de Par\xEDs de 2013 e incluido en el Sal\xF3n de la Fama de la FIE en 2014. Fue miembro de la Comisi\xF3n encargada del Baremo de Votos de la FIE, del Comit\xE9 disciplinario y presidi\xF3 el Consejo de Juego Limpio de la FIE. Ha sido presidente de DT en los Campeonatos del Mundo y supervisor habitual oficial de la Copa del mundo de la FIE.</p>\n        <p>Desde 2012, el Sr. van de Flier ha trabajado en el Comit\xE9 Internacional de Juego Limpio (CIFP) y ha sido su secretario tesorero desde 2015. Su trabajo permiti\xF3 la creaci\xF3n del Consejo de Juego Limpio de la FIE en 2017.</p>\n        <p>El Sr. van de Flier ha sido Miembro de Honor de la KNAS desde 1995 y particip\xF3 activamente en la organizaci\xF3n desde 1978. Presidi\xF3 su Comisi\xF3n T\xE9cnica antes de  convertirse en secretario general de la KNAS en 1981 y en presidente provisional en 1982. Se convirti\xF3 as\xED en el presidente m\xE1s joven de la KNAS, funci\xF3n que desempe\xF1\xF3 durante 12 a\xF1os. Despu\xE9s de abandonar el consejo en 1995, volvi\xF3 a unirse como secretario general en 2010, un cargo que todav\xEDa conserva. </p>\n        <p>Ayud\xF3 a fundar la Confederaci\xF3n Europea de Esgrima en 1991 y form\xF3 parte de su consejo durante 17 a\xF1os, siendo secretario general, primer vicepresidente, tesorero y presidente de la Comisi\xF3n SEMI. Se han organizado varios campeonatos del mundo y europeos en los Pa\xEDses Bajos desde 1985 hasta 1995 gracias a los esfuerzos del Sr. van de Flier, tambi\xE9n reconocido por su labor fundamental a la hora de promover que las competiciones Airborne Trophy y Zoetermeer Trophy se conviertan en (antiguas) Copas del mundo de la FIE en los Pa\xEDses Bajos.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg45Anim = new TimelineMax();\n          pg45Anim\n            .fromTo(cOf(\"45-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(idOf(\"45-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n        function togglePage45(show, hide) {\n          var show = idOf(show)\n          var hide = cOf(hide)\n          TweenMax.to(hide, 0.01, {opacity: 0});\n          TweenMax.to(show, 0.01, {opacity:1});\n        }\n        function onPageLeave() {\n          pg45Anim.stop();\n          resetNumbers(\"45-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "NOTICIAS DE L A FIE  NOTICIAS DE LA FIE Bert M.J. van de Flier (NED, MH) recibió la condecoración real de los Países Bajos Ver más aquí  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.fencewithfun.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 259px; right: 22px; width: 33px; height: 154px;\"></div>\n        </a>\n      ",
    "mobileHtml": "\n        <a href=\"https://www.fencewithfun.com\" target=\"_blank\">\n          <img src=\"/120/es/static/_content/pg46.jpg\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 47-title\" style=\"top:160px;left:65px;\" src=\"/120/es/static/_content/47-title-1.png\">\n        <img class=\"abs halfScale 47-sub\" style=\"top:388px;left:92px;\" src=\"/120/es/static/_content/47-sub-1.png\">\n        <img class=\"abs halfScale 47-line\" style=\"top:390px;left:64px;\" src=\"/120/es/static/_content/47-line-1.png\">\n        <img id=\"47-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-edge-green.png\">\n      ",
    "mobileHtml": "\n        <h2 id=\"togo-hosts-fencing-equipment-repair-course\">Togo acoge el Curso de reparaci\xF3n de equipamiento de esgrima</h2>\n        <img src=\"/120/es/static/_content/47-mobile-1.jpg\">\n        <p><strong>Lom\xE9, Togo <br>14 de enero de 2022</strong></p>\n        <p><strong>La Federaci\xF3n de Esgrima de Togo acogi\xF3 un curso de reparaci\xF3n de equipamiento de esgrima desde el 14 al 18 de diciembre de 2021, que alberg\xF3 14 participantes de cuatro ligas de esgrima de la regi\xF3n. </strong></p>\n        <p>El curso, celebrado a petici\xF3n del Presidente de la Federaci\xF3n Victor Lam\xE9ga, fue financiado por la FIE, que proporcion\xF3 formaci\xF3n especializada, equipamiento y herramientas. </p>\n        <p>El Sr. Gilles Martinage (FRA), que ha trabajado como armero oficial y ha gestionado el control de armas en numerosas pruebas a nivel mundial, se encarg\xF3 de la preparaci\xF3n y de la formaci\xF3n durante el curso. </p>\n        <p>Los 14 participantes contaban con diferentes niveles de experiencia, incluidos los atletas, los entrenadores, maestros de esgrima en Dakar o Argel, atletas que se estaban formando para ser entrenadores y el \xE1rbitro internacional y director t\xE9cnico de la Federaci\xF3n de Togo, el Sr. Koffi Kassefon. </p>\n        <p>Se proporcion\xF3 contenido te\xF3rico e informativo sobre los sistemas el\xE9ctricos de puntuaci\xF3n, los aspectos t\xE9cnicos del manejo de armas y los reglamentos actuales de los equipos. Los temas del curso englobaron la detecci\xF3n de anomal\xEDas, la reparaci\xF3n y el montaje completo de las armas, la comprobaci\xF3n de las instalaciones de la pista y la supervisi\xF3n adecuada del equipo personal (por ejemplo, hojas, cables que van al cuerpo, caretas, etc.). </p>\n        <p>El curso en general fue interactivo y pr\xE1ctico, y estuvo centrado en desarrollar y practicar las habilidades t\xE9cnicas. El contenido diario abord\xF3 los intereses, las habilidades y las expectativas personales de los participantes, y se centr\xF3 en garantizar que dichos participantes desarrollaran la capacidad de reproducir de manera consistente las t\xE9cnicas aprendidas. Para realizar los ejercicios pr\xE1cticos se utiliz\xF3 el equipamiento proporcionado por la FIE: 12 kits b\xE1sicos de reparaci\xF3n, tres maletines de armas y un kit especial para reparar bobinas de cable. El objetivo de estos ejercicios se basaba en la eficacia a la hora de rehabilitar las armas de competici\xF3n, estandarizar los cables que van al cuerpo, reparar bobinas, colocar los cables de la pista y reparar el aparato de puntuaci\xF3n. Los participantes aprendieron a examinar todo el equipamiento, a comprobar y detectar la existencia de anomal\xEDas, a determinar la realizaci\xF3n de reparaciones adecuadas y necesarias y a llevar a cabo las reparaciones, como soldar, unir cables a hojas y restaurar hilos conductores met\xE1licos para garantizar una buena conductividad. </p>\n        <p>Gracias al curso, los participantes aprendieron a evaluar y reparar de manera efectiva pr\xE1cticamente todas las armas de competici\xF3n de la FIE, as\xED como a probar y reparar los cables que van al cuerpo, a reparar los controles remotos de los sistemas de puntuaci\xF3n y a fabricar cables dise\xF1ados para conectar bobinas de cable a las armas. </p>\n        <p>Cuando se entregaron los certificados de participaci\xF3n a los aprendices, el Sr. Martinage destac\xF3 el entusiasmo de los participantes, as\xED como su excelente trabajo y su meticulosidad a lo largo del curso. El Presidente de la Federaci\xF3n de Togo, Lam\xE9ga tambi\xE9n elogi\xF3 el \xABesp\xEDritu de cohesi\xF3n\xBB que hab\xEDa prevalecido durante el programa.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg47Anim = new TimelineMax();\n          pg47Anim\n            .fromTo(cOf(\"47-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"47-line\"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)\n            .fromTo(cOf(\"47-sub\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)\n            .fromTo(idOf(\"47-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n        \n        function onPageLeave() {\n          pg47Anim.stop();\n          resetNumbers(\"47-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "NOTICIAS DE C ONFEDER ACIÓN Y FEDER ACIÓN  TOGO ACOGE EL CURSO DE REPARACIÓN DE EQUIPAMIENTO DE ESGRIMA LOMÉ, TOGO 14 DE ENERO DE 2022"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/es/static/_content/tw-green.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/es/static/_content/fb-green.png\">\n        </a>\n\n        <img id=\"48-next\" class=\"halfScale pointer\" style=\"top:647px;right:-95px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-edge-green.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg48Anim = new TimelineMax();\n          pg48Anim\n            .fromTo(idOf(\"48-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg48Anim.stop();\n          resetNumbers(\"48-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "NOTICIAS DE CONFEDERACIÓN Y FEDERACIÓN 2/3  La Federación de Esgrima de Togo acogió un curso de reparación de equipamiento de esgrima desde el 14 al 18 de diciembre de 2021, que albergó 14 participantes de cuatro ligas de esgrima de la región. El curso, celebrado a petición del Presidente de la Federación Victor Laméga, fue financiado por la FIE, que proporcionó formación especializada, equipamiento y herramientas. El Sr. Gilles Martinage (FRA), que ha trabajado como armero oficial y ha gestionado el control de armas en numerosas pruebas a nivel mundial, se encargó de la preparación y de la formación durante el curso.  Los 14 participantes contaban con diferentes niveles de experiencia, incluidos los atletas, los entrenadores, maestros de esgrima en Dakar o Argel, atletas que se estaban formando para ser entrenadores y el árbitro internacional y director técnico de la Federación de Togo, el Sr. Koffi Kassefon. Se proporcionó contenido teórico e informativo sobre los sistemas eléctricos de puntuación, los aspectos técnicos del manejo de armas y los reglamentos actuales de los equipos. Los temas del curso englobaron la detección de anomalías, la reparación y el montaje completo de las armas, la comprobación de las instalaciones de la pista y la supervisión adecuada del equipo personal (por ejemplo, hojas, cables que van al cuerpo, caretas, etc.). El curso en general fue interactivo y práctico, y estuvo centrado en desarrollar y practicar las habilidades técnicas. El contenido diario abordó los intereses, las habilidades y las expectativas personales de los participantes, y se centró en garantizar que dichos participantes"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:41px\"\n            src=\"/120/es/static/_content/tw-green.png\">\n        </a>\n        \n        <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n          <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:323px;left:94px\"\n            src=\"/120/es/static/_content/fb-green.png\">\n        </a>\n\n        <img id=\"49-next\" class=\"halfScale pointer\" style=\"top:647px;right:-79px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-pad-green.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg49Anim = new TimelineMax();\n          pg49Anim\n            .fromTo(idOf(\"49-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg49Anim.stop();\n          resetNumbers(\"49-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "la existencia de anomalías, a determinar la realización de reparaciones adecuadas y necesarias y a llevar a cabo las reparaciones, como soldar, unir cables a hojas y restaurar hilos conductores metálicos para garantizar una buena conductividad.  NOTICIAS DE CONFEDERACIÓN Y FEDERACIÓN 3/3  desarrollaran la capacidad de reproducir de manera consistente las técnicas aprendidas. Para realizar los ejercicios prácticos se utilizó el equipamiento proporcionado por la FIE: 12 kits básicos de reparación, tres maletines de armas y un kit especial para reparar bobinas de cable. El objetivo de estos ejercicios se basaba en la eficacia a la hora de rehabilitar las armas de competición, estandarizar los cables que van al cuerpo, reparar bobinas, colocar los cables de la pista y reparar el aparato de puntuación. Los participantes aprendieron a examinar todo el equipamiento, a comprobar y detectar  Gracias al curso, los participantes aprendieron a evaluar y reparar de manera efectiva prácticamente todas las armas de competición de la FIE, así como a probar y reparar los cables que van al cuerpo, a reparar los controles remotos de los sistemas de puntuación y a fabricar cables diseñados para conectar bobinas de cable a las armas. Cuando se entregaron los certificados de participación a los aprendices, el Sr. Martinage destacó el entusiasmo de los participantes, así como su excelente trabajo y su meticulosidad a lo largo del curso. El Presidente de la Federación de Togo, Laméga también elogió el «espíritu de cohesión» que había prevalecido durante el programa. ■  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "",
    "mobileHtml": "\n        <img src=\"/120/es/static/_content/50-mobile-1.jpg\">\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 51-title\" style=\"top:120px;left:66px;\" src=\"/120/es/static/_content/51-title-1.png\">\n\n        <img id=\"51-next\" class=\"halfScale pointer\" style=\"top:718px;right:-243px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-long-orange.png\">\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n\n        <div class=\"contentLink\" onclick=\"showOverlay('51-popups-1')\" style=\"bottom: 250px; right: 912px; width: 82px; height: 27px;\"></div>\n        <div class=\"contentLink\" onclick=\"showOverlay('51-popups-2')\" style=\"bottom: 483px; right: 321px; width: 64px; height: 23px;\"></div>\n\n        <div id=\"51-popups-1\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img id=\"51-pop-2-1\" class=\"halfScale 51-popup-2\" src=\"/120/es/static/_content/51-popup-1-1.png\" alt=\"\">\n          <div class=\"contentLink\" style=\"top: 56px; left: 1009px; width: 35px; height: 35px;\"\n            onclick=\"hideOverlay('51-popups-1');\"></div>  \n        </div>\n        <div id=\"51-popups-2\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img id=\"51-pop-2-1\" class=\"halfScale 51-popup-2A\" src=\"/120/es/static/_content/51-popup-2-1.png\" alt=\"\">\n          <img id=\"51-pop-2-2\" class=\"halfScale 51-popup-2\" src=\"/120/es/static/_content/51-popup-2-2.png\" style=\"opacity:0\" alt=\"\">\n          <div class=\"contentLink\" style=\"top: 798px; left: 600px; width: 125px; height: 48px;\"\n            onclick=\"togglePage51('51-pop-2-1', '51-popup-2');\"></div>\n          <div class=\"contentLink\" style=\"top: 798px; left: 755px; width: 125px; height: 48px;\"\n            onclick=\"togglePage51('51-pop-2-2', '51-popup-2');\"></div>\n          <div class=\"contentLink\" style=\"top: 55px; left: 1009px; width: 35px; height: 35px;\"\n            onclick=\"hideOverlay('51-popups-2');\"></div>\n        </div>\n      ",
    "mobileHtml": "\n        <h2 id=\"fie-news\">NOTICIAS DEL MUNDO</h2>\n        <p><strong>1<br>Celebrados los talleres Athlete365 Career+ en los Campeonatos\n            del mundo de esgrima juniors y cadetes de 2022 en Dub\xE1i</strong></p>\n        <img src=\"/120/es/static/_content/51-mobile-1.jpg\">\n        <p><strong>Antes del inicio de los Campeonatos del mundo de esgrima juniors y\n            cadetes de 2022 en Dub\xE1i (Emiratos \xC1rabes Unidos), se celebr\xF3 un taller\n            Athlete365 Career+ \xABPower-Up\xBB del COI para esgrimistas que estaban\n            participando en un curso oficial de entrenamiento de la FIE.</strong></p>\n        <p>TEl taller fue dirigido por Maria Ntanou, tres veces atleta ol\xEDmpica y\n          gerente de comunicaci\xF3n digital de la FIE, y en \xE9l participaron 16 esgrimistas\n          de 16 pa\xEDses. </p>\n        <p>El taller dur\xF3 medio d\xEDa y abarc\xF3 diferentes m\xF3dulos como, por ejemplo, c\xF3mo\n          identificar los puntos fuertes y los valores. </p>\n        <p>El taller ense\xF1a que no importa en qu\xE9 etapa de su carrera se encuentre, ya\n          que es importante tomarse tiempo para reflexionar y evaluar qui\xE9nes somos y\n          qu\xE9 deseamos conseguir en la vida. Saber cu\xE1les son sus aut\xE9nticas facultades\n          y lo que realmente le motiva y le impulsa le ayudar\xE1 en todos los aspectos de\n          su carrera y de su vida.</p>\n        <p>La primera sesi\xF3n se centr\xF3 en la autorreflexi\xF3n y en actividades entre\n          grupos de atletas, que respondieron a preguntas como: \xAB\xBFEn qu\xE9 destaco?\xBB, \xAB\xBFEn\n          qu\xE9 podr\xEDa ser mejor?\xBB y \xAB\xBFQu\xE9 es importante para m\xED?\xBB</p>\n        <p>Al final de la sesi\xF3n, los esgrimistas pudieron identificar tres puntos\n          fuertes principales de su personalidad y tres facultades que podr\xEDan\n          desarrollar a\xFAn m\xE1s. </p>\n        <p><strong>2<br>Celebrados los talleres Athlete365 Career+ en los Campeonatos\n            del mundo de esgrima juniors y cadetes de 2022 en Dub\xE1i</strong></p>\n        <img src=\"/120/es/static/_content/51-mobile-2.jpg\">\n        <p><strong>Hoy es el D\xEDa Internacional del Deporte para el Desarrollo y la Paz\n            (IDSDP, por sus siglas en ingl\xE9s), designado por la Asamblea General de las\n            Naciones Unidas, un movimiento que cuenta con el apoyo de la FIE.</strong>\n        </p>\n        <p>Cada a\xF1o, el 6 de abril, el mundo del deporte destaca el poder \xFAnico del\n          deporte en el apoyo a las personas y las comunidades para superar la\n          adversidad y contribuir de manera significativa como un facilitador\n          fundamental del desarrollo sostenible. Reconoce las actividades deportivas y\n          su influencia positiva hacia la paz y la armon\xEDa en la convivencia de las\n          comunidades de todo el mundo. </p>\n        <p>En los Campeonatos del Mundo de Esgrima Juveniles y Cadetes, que se celebran\n          del 2 al 10 de abril en Dubai (Emiratos \xC1rabes Unidos), se inform\xF3 a los\n          atletas sobre el IDSDP y, como es el s\xEDmbolo distintivo de la organizaci\xF3n, se\n          les pidi\xF3 que sostuvieran tarjetas blancas. Son una referencia a las tarjetas\n          amarillas y rojas de penalizaci\xF3n en el mundo del deporte, y desde 2014 una\n          #WhiteCard es el s\xEDmbolo que cre\xF3 la organizaci\xF3n \xABPeace and Sport\xBB, para\n          representar el poder positivo del deporte por la paz y la inclusi\xF3n social.\n        </p>\n        <p>Los atletas adolescentes internacionales que participan en los Campeonatos\n          del Mundo de Esgrima Juveniles y Cadetes de las tres armas de esgrima (espada,\n          florete y sable) y de ambos sexos aportaron sus opiniones sobre la iniciativa\n          del 6 de abril:</p>\n        <p>\xABEl deporte es una forma de vincularse con algo que todos tenemos en com\xFAn.\n          Aqu\xED hay miles de esgrimistas que dejan de lado sus diferencias para competir.\n          Por supuesto, no podemos hacerlo sin la paz\xBB.</p>\n        <p>Jakob Lars Kristmannson (ISL)</p>\n        <p>\xABLa paz y el deporte unen a las personas aunque haya competencia. Hay un\n          nivel de deportividad y comprensi\xF3n, as\xED que es una gran manera de unir a la\n          gente\xBB.\n          Sanojah Gilkes (BAR)</p>\n        <p>\xABLos deportes como la esgrima unen a las personas; quieren competir pero\n          tambi\xE9n quieren mostrar compa\xF1erismo. Como deportista, aunque se luche, se\n          quiere estar seguro de ser pac\xEDfico cuando no se compite para acercarse y\n          retroalimentarse de manera mutua\xBB.\n          Daniella Weng Yan Tang (SGP)</p>\n        <p>Seg\xFAn la organizaci\xF3n Peace and Sport, \xABa trav\xE9s de una #WhiteCard, cada uno\n          de nosotros puede defender el poder \xFAnico del deporte para el desarrollo\n          social y la paz y compartir una historia sobre c\xF3mo el deporte nos ayud\xF3 a\n          superar los desaf\xEDos\xBB.</p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg51Anim = new TimelineMax();\n          pg51Anim\n            .fromTo(cOf(\"51-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(idOf(\"51-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n        function togglePage51(show, hide) {\n          var show = idOf(show)\n          var hide = cOf(hide)\n          TweenMax.to(hide, 0.01, {opacity: 0});\n          TweenMax.to(show, 0.01, {opacity:1});\n        }\n        function onPageLeave() {\n          pg51Anim.stop();\n          resetNumbers(\"51-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "NOTICIAS DEL MUNDO  NOTICIAS DEL MUNDO 2  WWW.FIE.ORG  La FIE apoya el 6 de abril el Día Internacional del Deporte para el Desarrollo y la Paz Haga clic aquí para leer el artículo completo  1  Talleres Athlete365 Career+ en Dubái Haga clic aquí para leer el artículo completo  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "\n        <a href=\"mailto:jason@jiangfencing.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 76px; right: 352px; width: 235px; height: 19px;\"></div>\n        </a>\n        <a href=\"http://www.jiangfencing.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 97px; right: 377px; width: 211px; height: 17px;\"></div>\n        </a>\n      ",
    "mobileHtml": "\n        <a href=\"http://www.jiangfencing.com\" target=\"_blank\">\n          <img src=\"/120/es/static/_content/52-mobile-1.jpg\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 53-title\" style=\"top:41px;left:61px;\" src=\"/120/es/static/_content/53-title-1.png\">\n\n        <img id=\"53-next\" class=\"halfScale pointer\" style=\"top:719px;right:-184px\" onclick=\"Publish.goToNextPage()\"\n          src=\"/120/es/static/_content/arrow-long-navy.png\">\n        \n        <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 8px; right: 58px; width: 90px; height: 17px;\"></div>\n        </a>\n\n        <div id=\"53-1\" class=\"abs noOverflow 53-div\" style=\"top:299px; left: 65px; height: 520px; width: 810px; display: block;\">\n          <img id=\"53-text-1a\" class=\"halfScale 53-text-1\" style=\"top:0px;left:0px;\"\n            src=\"/120/es/static/_content/53-text-1-1.png\">\n          <img id=\"53-text-1b\" class=\"halfScale 53-text-1\" style=\"top:0px;left:0px; opacity:0;\"\n            src=\"/120/es/static/_content/53-text-1-2.png\">\n          <div id=\"53-btn-1a\" class=\"abs halfScale pointer 53-btn-1\"\n            style=\"top: 430px; left: 397px; width: 251px; height: 96px;\"\n            onclick=\"togglePage('53-btn-1a', '53-btn-1', '53-text-1a', '53-text-1')\"></div>\n          <div id=\"53-btn-1b\" class=\"abs halfScale pointer 53-btn-1\"\n            style=\"top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;\"\n            onclick=\"togglePage('53-btn-1b', '53-btn-1', '53-text-1b', '53-text-1')\"></div>\n        </div>\n        \n        <div id=\"53-2\" class=\"abs noOverflow 53-div\" style=\"top:299px;left:65px;height:700px;width:880px;display:none\">\n          <img id=\"53-text-2a\" class=\"halfScale 53-text-2\" style=\"top:0px;left:0px;\"\n            src=\"/120/es/static/_content/53-text-2-1.png\">\n          <img id=\"53-text-2b\" class=\"halfScale 53-text-2\" style=\"top:0px;left:0px; opacity:0;\"\n            src=\"/120/es/static/_content/53-text-2-2.png\">\n          <div id=\"53-btn-2a\" class=\"abs halfScale pointer 53-btn-2\"\n            style=\"top: 430px; left: 397px; width: 251px; height: 96px;\"\n            onclick=\"togglePage('53-btn-2a', '53-btn-2', '53-text-2a', '53-text-2')\"></div>\n          <div id=\"53-btn-2b\" class=\"abs halfScale pointer 53-btn-2\"\n            style=\"top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;\"\n            onclick=\"togglePage('53-btn-2b', '53-btn-2', '53-text-2b', '53-text-2')\"></div>\n        </div>\n        \n        <div id=\"53-3\" class=\"abs noOverflow 53-div\" style=\"top:299px;left:65px;height:700px;width:880px;display:none\">\n          <img id=\"53-text-3a\" class=\"halfScale 53-text-3\" style=\"top:0px;left:0px;\"\n            src=\"/120/es/static/_content/53-text-3-1.png\">\n          <img id=\"53-text-3b\" class=\"halfScale 53-text-3\" style=\"top:0px;left:0px; opacity:0;\"\n            src=\"/120/es/static/_content/53-text-3-2.png\">\n          <div id=\"53-btn-3a\" class=\"abs halfScale pointer 53-btn-3\"\n            style=\"top: 430px; left: 397px; width: 251px; height: 96px;\"\n            onclick=\"togglePage('53-btn-3a', '53-btn-3', '53-text-3a', '53-text-3')\"></div>\n          <div id=\"53-btn-3b\" class=\"abs halfScale pointer 53-btn-3\"\n            style=\"top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;\"\n            onclick=\"togglePage('53-btn-3b', '53-btn-3', '53-text-3b', '53-text-3')\"></div>\n        </div>\n        \n        <div id=\"53-4\" class=\"abs noOverflow 53-div\" style=\"top:299px;left:65px;height:700px;width:880px;display:none\">\n          <img id=\"53-text-4a\" class=\"halfScale 53-text-4\" style=\"top:0px;left:0px;\"\n            src=\"/120/es/static/_content/53-text-4-1.png\">\n          <img id=\"53-text-4b\" class=\"halfScale 53-text-4\" style=\"top:0px;left:0px; opacity:0;\"\n            src=\"/120/es/static/_content/53-text-4-2.png\">\n          <img id=\"53-text-4c\" class=\"halfScale 53-text-4\" style=\"top:0px;left:0px; opacity:0;\"\n            src=\"/120/es/static/_content/53-text-4-3.png\">\n          <div id=\"53-btn-4a\" class=\"abs halfScale pointer 53-btn-4\"\n            style=\"top: 430px; left: 397px; width: 251px; height: 96px;\"\n            onclick=\"togglePage('53-btn-4a', '53-btn-4', '53-text-4a', '53-text-4')\"></div>\n          <div id=\"53-btn-4b\" class=\"abs halfScale pointer 53-btn-4\"\n            style=\"top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;\"\n            onclick=\"togglePage('53-btn-4b', '53-btn-4', '53-text-4b', '53-text-4')\"></div>\n          <div id=\"53-btn-4c\" class=\"abs halfScale pointer 53-btn-4\"\n            style=\"top: 430px; left: 705px; width: 251px; height: 96px;opacity:0;\"\n            onclick=\"togglePage('53-btn-4c', '53-btn-4', '53-text-4c', '53-text-4')\"></div>\n        </div>\n        \n        <div id=\"53-5\" class=\"abs noOverflow 53-div\" style=\"top:299px;left:65px;height:700px;width:880px;display:none\">\n          <img id=\"53-text-5a\" class=\"halfScale 53-text-5\" style=\"top:0px;left:0px;\"\n            src=\"/120/es/static/_content/53-text-5-1.png\">\n          <img id=\"53-text-5b\" class=\"halfScale 53-text-5\" style=\"top:0px;left:0px; opacity:0;;\"\n            src=\"/120/es/static/_content/53-text-5-2.png\">\n          <img id=\"53-text-5c\" class=\"halfScale 53-text-5\" style=\"top:0px;left:0px; opacity:0;;\"\n            src=\"/120/es/static/_content/53-text-5-3.png\">\n          <div id=\"53-btn-5a\" class=\"abs halfScale pointer 53-btn-5\"\n            style=\"top: 430px; left: 397px; width: 251px; height: 96px;\"\n            onclick=\"togglePage('53-btn-5a', '53-btn-5', '53-text-5a', '53-text-5')\"></div>\n          <div id=\"53-btn-5b\" class=\"abs halfScale pointer 53-btn-5\"\n            style=\"top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;\"\n            onclick=\"togglePage('53-btn-5b', '53-btn-5', '53-text-5b', '53-text-5')\"></div>\n          <div id=\"53-btn-5c\" class=\"abs halfScale pointer 53-btn-5\"\n            style=\"top: 430px; left: 705px; width: 251px; height: 96px;opacity:0;\"\n            onclick=\"togglePage('53-btn-5c', '53-btn-5', '53-text-5c', '53-text-5')\"></div>\n        </div>\n        \n        <div id=\"53-6\" class=\"abs noOverflow 53-div\" style=\"top:299px;left:65px;height:700px;width:880px;display:none\">\n          <img id=\"53-text-6a\" class=\"halfScale 53-text-6\" style=\"top:0px;left:0px;\"\n            src=\"/120/es/static/_content/53-text-6-1.png\">\n          <img id=\"53-text-6b\" class=\"halfScale 53-text-6\" style=\"top:0px;left:0px; opacity:0;\"\n            src=\"/120/es/static/_content/53-text-6-2.png\">\n          <img id=\"53-text-6c\" class=\"halfScale 53-text-6\" style=\"top:0px;left:0px; opacity:0;\"\n            src=\"/120/es/static/_content/53-text-6-3.png\">\n          <div id=\"53-btn-6a\" class=\"abs halfScale pointer 53-btn-6\"\n            style=\"top: 430px; left: 397px; width: 251px; height: 96px;\"\n            onclick=\"togglePage('53-btn-6a', '53-btn-6', '53-text-6a', '53-text-6')\"></div>\n          <div id=\"53-btn-6b\" class=\"abs halfScale pointer 53-btn-6\"\n            style=\"top: 430px; left: 550px; width: 251px; height: 96px;opacity:0;\"\n            onclick=\"togglePage('53-btn-6b', '53-btn-6', '53-text-6b', '53-text-6')\"></div>\n          <div id=\"53-btn-6c\" class=\"abs halfScale pointer 53-btn-6\"\n            style=\"top: 430px; left: 705px; width: 251px; height: 96px;opacity:0;\"\n            onclick=\"togglePage('53-btn-6c', '53-btn-6', '53-text-6c', '53-text-6')\"></div>\n        </div>\n        \n        <img id=\"53-cta-1\" class=\"halfScale pointer 53-btn\" style=\"top:258px;left:869px;transform:scale(0.506,0.52);\"\n          onclick=\"pg53Toggle('53-1', '53-cta-1');\" src=\"/120/es/static/_content/53-name-1.png\">\n        <img id=\"53-cta-2\" class=\"halfScale pointer 53-btn\" style=\"top:325px;left:869px;transform:scale(0.506,0.52);opacity:0\"\n          onclick=\"pg53Toggle('53-2', '53-cta-2');\" src=\"/120/es/static/_content/53-name-2.png\">\n        <img id=\"53-cta-3\" class=\"halfScale pointer 53-btn\" style=\"top:393px;left:869px;transform:scale(0.506,0.52);opacity:0\"\n          onclick=\"pg53Toggle('53-3', '53-cta-3');\" src=\"/120/es/static/_content/53-name-3.png\">\n        <img id=\"53-cta-4\" class=\"halfScale pointer 53-btn\" style=\"top:461px;left:869px;transform:scale(0.506,0.52);opacity:0\"\n          onclick=\"pg53Toggle('53-4', '53-cta-4');\" src=\"/120/es/static/_content/53-name-4.png\">\n        <img id=\"53-cta-5\" class=\"halfScale pointer 53-btn\" style=\"top:528px;left:869px;transform:scale(0.506,0.52);opacity:0\"\n          onclick=\"pg53Toggle('53-5', '53-cta-5');\" src=\"/120/es/static/_content/53-name-5.png\">\n        <img id=\"53-cta-6\" class=\"halfScale pointer 53-btn\" style=\"top:595px;left:869px;transform:scale(0.506,0.52);opacity:0\"\n          onclick=\"pg53Toggle('53-6', '53-cta-6');\" src=\"/120/es/static/_content/53-name-6.png\">\n      ",
    "mobileHtml": "\n        <h2 id=\"obituaries\">NECROL\xD3GICAS</h2>\n        <p><strong>1<br>Jahangir Safarov (AZE)</strong></p>\n        <img src=\"/120/es/static/_content/53-mobile-1.png\">\n        <p><strong>La FIE lamenta el fallecimiento de Jahangir Safarov (AZE) el 12 de noviembre.</strong></p>\n        <p>Fue entrenador del equipo nacional de esgrima de Azerbaiy\xE1n y \xE1rbitro nacional. Naci\xF3 el 9 de marzo de 1968. </p>\n        <p>Safarov comenz\xF3 a practicar la esgrima a los 10 a\xF1os. Lleg\xF3 a ser medallista en numerosas competencias de la URSS y particip\xF3 en Campeonatos del Mundo y de Europa, y fue nombrado Maestro del Deporte de la URSS en 1985.</p>\n        <p>En 2001, se convirti\xF3 en el entrenador del equipo nacional de Azerbaiy\xE1n, del que salieron varios campeones nacionales y medallistas en pruebas internacionales y regionales, y fue el entrenador principal de sable femenino cadetes. La alumna de Safarov, Zarifa Huseynova, gan\xF3 la medalla de bronce en sable femenino cadetes individual en los Campeonatos del Mundo de Esgrima Juveniles y Cadetes de El Cairo en 2021. Su hijo, Javanshir Safarov, al que tambi\xE9n entren\xF3, obtuvo la plata en sable masculino en la Copa del Mundo Juvenil de Teher\xE1n en diciembre de 2013. </p>\n        <p>En nombre de la familia mundial de la esgrima, la FIE ofrece sus m\xE1s sinceras condolencias a la familia y los amigos de Jahangir Safarov, a la Federaci\xF3n de Esgrima de Azerbaiy\xE1n y a la Confederaci\xF3n Europea de Esgrima, y expresamos nuestro m\xE1s profundo p\xE9same en estos momentos tan dif\xEDciles.</p>\n        <p><strong>2<br>Alex Orban (EE. UU.)</strong></p>\n        <img src=\"/120/es/static/_content/53-mobile-2.png\">\n        <p><strong>La FIE lamenta el fallecimiento de Alex Orban (EE. UU.) el 2 de diciembre a la edad de 82 a\xF1os, compiti\xF3 tres veces en los Juegos Ol\xEDmpicos como esgrimista de sable.</strong></p>\n        <p>Naci\xF3 el 25 de agosto de 1939 en Budapest (Hungr\xEDa) y comenz\xF3 a practicar la esgrima a los 14 a\xF1os. A los 16 a\xF1os era el esgrimista m\xE1s joven que hab\xEDa logrado una clasificaci\xF3n de primera clase en Hungr\xEDa y se le calific\xF3 como la \xABpr\xF3xima estrella del equipo magiar\xBB. </p>\n        <p>El Sr. Orban se traslad\xF3 a EE. UU. y, despu\xE9s de prestar tres a\xF1os de servicio militar, entren\xF3 y compiti\xF3 en esgrima. Form\xF3 parte del equipo ol\xEDmpico de esgrima de EE. UU. en los Juegos Ol\xEDmpicos de 1968 (Ciudad de M\xE9xico), 1972 (M\xFAnich) y 1976 (Montreal). </p>\n        <p>Fue campe\xF3n nacional de sable de EE. UU. en 1965 y todos los a\xF1os de 1969 a 1972, as\xED como campe\xF3n de sable individual en los Juegos Panamericanos de 1971 en Cali, Colombia. Tambi\xE9n gan\xF3 la medalla de plata en sable masculino por equipos en los Juegos Panamericanos de 1971 y 1975 (Ciudad de M\xE9xico). Fue el primer esgrimista de sable estadounidense en ganar una prueba internacional de categor\xEDa \xABA\xBB en 1968 en Lodz (Polonia).</p>\n        <p>El Sr. Orban fue incluido en el Sal\xF3n de la Fama de la Esgrima de EE. UU. en 1999. En nombre de la familia mundial de esgrima, la FIE ofrece sus m\xE1s sinceras condolencias a la familia y amigos de Alex Orban, al equipo de Esgrima de EE. UU. y a la Confederaci\xF3n Panamericana de Esgrima, y les expresamos nuestro m\xE1s sentido p\xE9same en estos momentos tan dif\xEDciles.\n        </p>\n        <p><strong>3<br>Ali Youssef Hussain (KUW, MH)</strong></p>\n        <img src=\"/120/es/static/_content/53-mobile-3.png\">\n        <p><strong>La FIE lamenta el fallecimiento, el 26 de diciembre, de Ali Youssef Hussain (KUW), Miembro de honor de la FIE y miembro del Sal\xF3n de la Fama. Naci\xF3 en 1938.</strong></p>\n        <p>Ex miembro del Comit\xE9 Ejecutivo de la FIE (2001-2008), el Congreso lo nombr\xF3 Miembro de honor en 2008. De 1985 a 2004, fue miembro de la Comisi\xF3n de Propaganda de la FIE (ahora denominada Comisi\xF3n de Promoci\xF3n, Comunicaci\xF3n y Marketing). </p>\n        <p>En 1977, fue elegido miembro de la Asociaci\xF3n de Esgrima Amateur de Kuwait, ejerciendo a lo largo del tiempo como su presidente durante ocho a\xF1os, as\xED como miembro de la Junta Directiva y del Comit\xE9 T\xE9cnico, y gestor de productos de la organizaci\xF3n. El Sr. Hussain fue miembro de la Junta Directiva del Comit\xE9 Ol\xEDmpico Nacional de Kuwait, y fue su secretario-tesorero desde 1994 hasta 2014. </p>\n        <p>Desde muy joven particip\xF3 en varios deportes, y durante muchos a\xF1os fue miembro del Club Deportivo Yarmouk, desde 1965, a\xF1o de su fundaci\xF3n. Form\xF3 parte de su junta directiva durante 10 a\xF1os y fue su secretario general y presidente.</p>\n        <p>Entre varios programas educativos, el Sr. Hussain asisti\xF3 a un curso ol\xEDmpico internacional de gesti\xF3n deportiva en 1987. Tambi\xE9n estudi\xF3 gesti\xF3n y ciencias del deporte con la supervisi\xF3n de la Federaci\xF3n Deportiva \xC1rabe, lo que le permiti\xF3, a partir de 1988, seguir su carrera en la administraci\xF3n deportiva. </p>\n        <p>La FIE ofrece sus sinceras condolencias y expresa su m\xE1s profundo p\xE9same a la familia y amigos de Ali Youssef Hussain, a la Asociaci\xF3n de Esgrima Amateur de Kuwait y a la Confederaci\xF3n Asi\xE1tica de Esgrima.</p>\n        <p><strong>4<br>Olga Orban-Szabov (ROM)</strong></p>\n        <img src=\"/120/es/static/_content/53-mobile-4.png\">\n        <p><strong>La FIE est\xE1 entristecida por la noticia del fallecimiento, que tuvo lugar el d\xEDa 5 de enero, de Olga Orban-Szabo (ROM), quien fue medallista ol\xEDmpica en numerosas ocasiones, campeona del mundo y miembro del Sal\xF3n de la Fama de la FIE. </strong></p>\n        <p>Nacida el 9 de octubre de 1938 en Cluj, la Sra. Szabo fue la primera medallista ol\xEDmpica y campeona del mundo de Ruman\xEDa, y compiti\xF3 en cinco Juegos Ol\xEDmpicos (Melbourne 1956, Roma 1960, Tokio 1964, Ciudad de M\xE9xico 1968 y M\xFAnich 1972). Gan\xF3 su primera medalla ol\xEDmpica, una plata en florete femenino individual, en Melbourne, y posteriormente una medalla de bronce en florete femenino por equipos, en los Juegos de Ciudad de M\xE9xico y de M\xFAnich. \n        </p>\n        <p>Se convirti\xF3 en campeona mundial de florete femenino individual en los Campeonatos del Mundo de Buenos Aires de 1962. Como parte del equipo rumano de florete femenino (en el que se incluyen Maria Vicol, Ileana Gyulai, Ecaterina Stahl y Ana Pascu), obtuvo una medalla de oro en los Campeonatos del Mundo de la Havana de 1969, otra primera medalla para su pa\xEDs. \n        </p>\n        <p>En definitiva, la Sra. Orban-Szabo gan\xF3 11 medallas ol\xEDmpicas y de Campeonatos del Mundo en florete femenino, incluidas tres medallas de los Juegos Ol\xEDmpicos y ocho de los Campeonatos del Mundo entre 1961 y 1970. Anteriormente, fue medallista de plata juvenil a nivel mundial en 1959.</p>\n        <p>Tambi\xE9n gan\xF3 tres medallas en las Universiadas, incluida la plata individual y el oro por equipos en 1961 y la plata por equipos en 1965.  </p>\n        <p>Como miembro del club de armas \xABSteaua Bucarest\xBB, gan\xF3 siete veces el campeonato nacional de Ruman\xEDa, y obtuvo el t\xEDtulo nacional de \xABEmeritus Master of Sport\xBB, as\xED como numerosas \xF3rdenes y t\xEDtulos rumanos. Se gradu\xF3 en la Universidad de Babes-Bolyai en Cluj-Napoca y tambi\xE9n fue maestra de esgrima. Tras su retirada de la competici\xF3n en 1972, trabaj\xF3 como entrenadora de esgrima juvenil en su club de Bucarest.</p>\n        <p>\xABFue una dama distinguida del equipo de esgrima rumano\xBB, afirm\xF3 Marius Florea, Presidente de la Federaci\xF3n de Ruman\xEDa. \xABLa Federaci\xF3n de Esgrima de Ruman\xEDa desea expresar su profunda gratitud a la Sra. Olga Orban-Szabo por su contribuci\xF3n a la fundaci\xF3n de la familia rumana de esgrima\xBB. </p>\n        <p>La FIE presenta sus m\xE1s sinceras condolencias y su profundo p\xE9same a la familia y a los amigos de Olga Orban-Szabo, as\xED como a la Federaci\xF3n de Esgrima de Ruman\xEDa y a la Confederaci\xF3n Europea de Esgrima.</p>\n        <p><strong>5<br>Jose Valarinho (POR)</strong></p>\n        <img src=\"/120/es/static/_content/53-mobile-5.png\">\n        <p><strong>La FIE est\xE1 entristecida por la noticia del fallecimiento de Jose Valarinho (POR) el d\xEDa 30 de marzo de 2022 a los 87 a\xF1os de edad. Jose Valarinho fue miembro del Sal\xF3n de la Fama de la FIE. Asimismo, fue miembro de la Comisi\xF3n Disciplinaria de la FIE desde 1996 hasta 2004.</strong></p>\n        <p>Fue galardonado con una medalla de oro especial de la FIE en tres ocasiones por su trabajo acad\xE9mico sobre la esgrima, as\xED como por organizar el Congreso de la FIE de 1988 en Madeira y los Campeonatos del mundo de Lisboa de 2002. Tambi\xE9n recibi\xF3 la Orden Ol\xEDmpica del Comit\xE9 Ol\xEDmpico Portugu\xE9s y la Medalla al M\xE9rito Deportivo por parte del gobierno portugu\xE9s. </p>\n        <p>El Sr. Valarinho fue presidente de la Federaci\xF3n Portuguesa de Esgrima durante dos mandatos a partir de 1992. Se uni\xF3 a la organizaci\xF3n en 1969 como presidente de la Comisi\xF3n T\xE9cnica y durante varias d\xE9cadas ejerci\xF3 una gran influencia sobre el crecimiento y el desarrollo de la esgrima en Portugal. Particip\xF3 en un \xABPlan para el Desarrollo del Deporte\xBB con un programa especial, \xAB500 Floretes\xBB, y trabaj\xF3 para ayudar a Portugal a desempe\xF1ar un papel m\xE1s activo en la esgrima internacional. </p>\n        <p>El Sr. Valarinho particip\xF3 en la organizaci\xF3n del primer Campeonato de Europa en Lisboa, en 1983, as\xED como en numerosas competiciones continentales y mundiales celebradas en Portugal durante las d\xE9cadas de 1980 y 1990. Su idea de que los portugueses se convirtieran en participantes de peso en la esgrima mundial se hizo realidad cuando el equipo de florete masculino de su pa\xEDs gan\xF3 la medalla de oro en el Campeonato de Europa de 2000 celebrado en Madeira. Tras dejar la presidencia, organiz\xF3 con \xE9xito los Campeonatos del mundo de Esgrima de Lisboa de 2002. </p>\n        <p>Con educaci\xF3n militar tradicional portuguesa, el Sr. Valarinho finalmente se convirti\xF3 en oficial del ej\xE9rcito, y fue durante su educaci\xF3n cuando tuvo el primer contacto con la esgrima y se convirti\xF3 en un experto ecuestre. Se gradu\xF3 con honores como ma\xEEtre en el Centro Deportivo Militar de Mafra, donde fue un esgrimista competitivo y particip\xF3 en la Universiada de 1959 como miembro del equipo de sable masculino. Despu\xE9s de la escuela, se convirti\xF3 en maestro de esgrima, especializado en la selecci\xF3n y el desarrollo de j\xF3venes esgrimistas.</p>\n        <p>Fue autor de dos libros sobre historia de la esgrima portuguesa y estaba preparando una tercera edici\xF3n. </p>\n        <p>\xABFue esgrimista hasta el d\xEDa de su muerte\xBB, afirm\xF3 su hijo Frederico Valarinho, miembro de la Federaci\xF3n Portuguesa de Esgrima desde 2006.</p>\n        <p>La FIE presenta sus m\xE1s sinceras condolencias a la familia y a los amigos de Jose Valarinho, as\xED como a la Federaci\xF3n Portuguesa de Esgrima y a la Confederaci\xF3n Europea de Esgrima. Les expresamos nuestro m\xE1s profundo p\xE9same en estos dif\xEDciles momentos.</p>\n        <p> <strong>6<br>Ana Pascu (ROU, MH)</strong></p>\n        <img src=\"/120/es/static/_content/53-mobile-6.png\">\n        <p><strong>La FIE lamenta profundamente el fallecimiento en Bucarest, el 6 de abril de 2022, de la Sra. Ana Pascu (ROU), Miembro de Honor de la FIE y miembro del Sal\xF3n de la Fama. Naci\xF3 el 22 de septiembre de 1944.</strong> </p>\n        <p>Elegida en el a\xF1o 2000, la Sra. Pascu ha sido miembro del Comit\xE9 Ejecutivo de la FIE, y ha sido vicepresidenta de 2004 a 2021. Anteriormente, fue miembro de la Comisi\xF3n del Reglamento de la FIE de 1984 a 1988 y de la Comisi\xF3n de Arbitraje de la FIE de 1988 a 1996. Tambi\xE9n fue \xE1rbitro internacional de la FIE en florete y espada. </p>\n        <p>Tiene el r\xE9cord de ser la presidenta m\xE1s longeva de la Federaci\xF3n Rumana de Esgrima. De 1982 a 2013, la Sra. Pascu dirigi\xF3 la Federaci\xF3n, contribuyendo a los logros deportivos de los esgrimistas rumanos, que ganaron 134 medallas durante su mandato, incluidas nueve en los Juegos Ol\xEDmpicos, 57 en los Campeonatos del Mundo y 68 en los Campeonatos de Europa. Tras su retirada como presidenta, fue nombrada presidenta de honor de la Federaci\xF3n Rumana de Esgrima. Tambi\xE9n fue vicepresidenta del Comit\xE9 Ol\xEDmpico y Deportivo Rumano. </p>\n        <p>Como atleta, Pascu fue cinco veces floretista ol\xEDmpica, y en florete por equipos gan\xF3 una medalla de bronce en los Juegos Ol\xEDmpicos de 1968 y 1972 y la medalla de oro en los Campeonatos del Mundo de La Habana en 1969. En florete individual, gan\xF3 el Campeonato del Mundo junior en 1963, as\xED como la medalla de bronce en el Campeonato del Mundo de 1971. Como parte del equipo rumano de florete femenino, gan\xF3 la medalla de plata en florete por equipos en los Campeonatos del Mundo de 1970 y las medallas de bronce en los Campeonatos del Mundo de 1961, 1967, 1971, 1973, 1974 y 1975. En 1961 y 1965, su equipo gan\xF3 el oro y la plata, respectivamente, en los Juegos Mundiales Universitarios (\xABUniversiadas\xBB). </p>\n        <p>La Sra. Pascu tambi\xE9n hizo carrera como entrenadora de esgrima y profesora de educaci\xF3n f\xEDsica hasta 1982, habiendo obtenido un doctorado en educaci\xF3n f\xEDsica y deporte. Su tesis doctoral se titul\xF3 La estrategia para mejorar la preparaci\xF3n deportiva en las competencias. Tambi\xE9n es \xABDoctora Honoris Causa\xBB por la Universidad Vasile Goldis de Ruman\xEDa. Fue autora de numerosas publicaciones cient\xEDficas y deportivas y recibi\xF3 varios t\xEDtulos y condecoraciones, como la Orden Nacional del M\xE9rito en grado de Oficial y Caballero.   La Sra. Pascu dedic\xF3 toda su vida a la esgrima, a los esgrimistas, a la esgrima rumana y a la FIE, y los numerosos \xE9xitos resultantes son testimonio de su incre\xEDble talento y pasi\xF3n por nuestro deporte. En palabras de Emmanuel Katsiadakis, Presidente interino de la FIE, \xABElla ayud\xF3, apoy\xF3 y motiv\xF3 incansablemente y con infinita amabilidad a todos los que buscaron su ayuda y consejo. Fue una destacada mentora y modelo de conducta para los atletas, funcionarios y dirigentes de la esgrima, as\xED como para las ni\xF1as y mujeres del deporte.\xBB  La FIE ofrece sus m\xE1s sinceras condolencias por su p\xE9rdida a la hermana de la Sra. Pascu, Nicoleta, a su familia y amigos, a la Federaci\xF3n Rumana de Esgrima y a la Confederaci\xF3n Europea de Esgrima, y expresa su m\xE1s sentido p\xE9same en estos momentos tan dif\xEDciles.  </p>\n      ",
    "script": "\n        function onPageEnter() {\n          pg53Anim = new TimelineMax();\n          pg53Anim\n            .to(idOf(\"53-1\"), 0.3,{display: 'block'}, 0)\n            .fromTo(cOf(\"53-title\"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n            .fromTo(idOf(\"53-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function pg53Toggle(id, btn) {\n          var ele = idOf(id)\n          var but = idOf(btn)\n          TweenMax.to(cOf(\"53-div\"), 0.01, {display: 'none'});\n          TweenMax.to(cOf(\"53-btn\"), 0.01, {opacity: 0});\n          TweenMax.to(ele, 0.1, {display: 'block'});\n          TweenMax.to(but, 0.1, {opacity: 1});\n        }\n        \n        function togglePage(id, klass, text, texttwo) {\n          var ele = idOf(id)\n          var but = cOf(klass)\n          var txt = idOf(text)\n          var txt2 = cOf(texttwo)\n          TweenMax.to(but, 0.01, {opacity: 0});\n          TweenMax.to(txt2, 0.01, {opacity: 0});\n          TweenMax.to(ele, 0.01, {opacity:1});\n          TweenMax.to(txt, 0.01, {opacity:1});\n        }\n        \n        function onPageLeave(){\n          pg53Toggle('53-text-1', '53-cta-1');\n          togglePage('53-btn-1', '53-btn-2', '53-text-1', '53-text-1');\n          pg53Anim.stop();\n          resetNumbers(\"53-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "RECUERDO  NECROLÓGICAS JAHANGIR SAFAROV  JAHANGIR SAFAROV (AZE) y participó en Campeonatos del Mundo y de Europa, y fue nombrado Maestro del Deporte de la URSS en 1985.  La FIE lamenta el fallecimiento de Jahangir Safarov (AZE) el 12 de noviembre. Fue entrenador del equipo nacional de esgrima de Azerbaiyán y árbitro nacional. Nació el 9 de marzo de 1968. Safarov comenzó a practicar la esgrima a los 10 años. Llegó a ser medallista en numerosas competencias de la URSS  En 2001, se convirtió en el entrenador del equipo nacional de Azerbaiyán, del que salieron varios campeones nacionales y medallistas en pruebas internacionales y regionales, y fue el entrenador principal de sable femenino cadetes. La alumna de Safarov, Zarifa Huseynova, ganó la medalla de bronce en sable femenino cadetes individual en los Campeonatos del Mundo  ALEX ORBAN  ALI YOUSSEF HUSSAIN  OLGA ORBAN-SZABO  JOSE VALARINHO  ANA PASCU  s Pulse arriba para ver  1  2  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": "\n        <a href=\"http://www.gfencing.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 186px; right: 599px; width: 228px; height: 38px;\"></div>\n        </a>\n        <a href=\"mailto:sales@gfencing.com\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom: 186px; right: 340px; width: 236px; height: 38px;\"></div>\n        </a>\n      ",
    "mobileHtml": "\n        <a href=\"http://www.gfencing.com\" target=\"_blank\">\n          <img src=\"/120/es/static/_content/54-mobile-1.jpg\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))\n        \n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n        contentLinksThree.map(function callback(e) { \n          return e.className = 'addContentLinkThree'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))\n\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n        contentLinksThree.map(function callback(e) {\n          return e.className = 'contentLinkThree addContentLinkThree'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n\n      function individualGallery(index) {\n        Publish.openGalleryTwo([['8-gal-1.jpg', '8-gal-2.jpg'], index])\n      }\n    ",
  "mobilePages": [{
    title: "Escrime XXI No. 120",
    link: "Escrime XXI No. 120",
    cssClass: "cover mobile-p1",
    hideInMenu: false,
    pageLinks: [{
      index: 0,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 2,
      subIndex: 0
    }]
  }, {
    title: "COMITÉ EJECUTIVO DE LA FIE",
    link: "COMITÉ EJECUTIVO DE LA FIE",
    cssClass: "blue",
    hideInMenu: false,
    pageLinks: [{
      index: 4,
      subIndex: 0
    }]
  }, {
    title: "PRÓLOGO",
    link: "PRÓLOGO",
    cssClass: "darkblue",
    hideInMenu: false,
    pageLinks: [{
      index: 5,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 6,
      subIndex: 0
    }]
  }, {
    title: "DEPORTE",
    link: "DEPORTE | Tashkent",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 7,
      subIndex: 0
    }]
  }, {
    title: "DEPORTE",
    link: "DEPORTE | Orleans",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 9,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 12,
      subIndex: 0
    }]
  }, {
    title: "DEPORTE",
    link: "DEPORTE | Tallinn",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 13,
      subIndex: 0
    }]
  }, {
    title: "DEPORTE",
    link: "DEPORTE | Bern",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 16,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 18,
      subIndex: 0
    }]
  }, {
    title: "DEPORTE",
    link: "DEPORTE | St Maur",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 19,
      subIndex: 0
    }]
  }, {
    title: "DEPORTE",
    link: "DEPORTE | Paris",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 21,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 23,
      subIndex: 0
    }]
  }, {
    title: "DEPORTE",
    link: "DEPORTE | Poznan",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 24,
      subIndex: 0
    }]
  }, {
    title: "DEPORTE",
    link: "DEPORTE | Tbilisi",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 26,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 29,
      subIndex: 0
    }]
  }, {
    title: "DEPORTE",
    link: "DEPORTE | Plovdiv",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 30,
      subIndex: 0
    }]
  }, {
    title: "DEPORTE",
    link: "DEPORTE | Doha",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 32,
      subIndex: 0
    }]
  }, {
    title: "DEPORTE",
    link: "DEPORTE | Budapest",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 34,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 37,
      subIndex: 0
    }]
  }, {
    title: "DEPORTE",
    link: "DEPORTE | Dubai",
    cssClass: "red",
    hideInMenu: false,
    pageLinks: [{
      index: 38,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 43,
      subIndex: 0
    }]
  }, {
    title: "FIE",
    link: "Noticias de la FIE",
    cssClass: "pink",
    hideInMenu: false,
    pageLinks: [{
      index: 44,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 45,
      subIndex: 0
    }]
  }, {
    title: "Noticias de confederación y federación",
    link: "Noticias de confederación y federación | Togo",
    cssClass: "green",
    hideInMenu: false,
    pageLinks: [{
      index: 46,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 49,
      subIndex: 0
    }]
  }, {
    title: "NOTICIAS DEL MUNDO",
    link: "NOTICIAS DEL MUNDO",
    cssClass: "orange",
    hideInMenu: false,
    pageLinks: [{
      index: 50,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 51,
      subIndex: 0
    }]
  }, {
    title: "NECROLÓGICAS",
    link: "NECROLÓGICAS",
    cssClass: "grey",
    hideInMenu: false,
    pageLinks: [{
      index: 52,
      subIndex: 0
    }]
  }, {
    title: "Advert",
    link: "Advert",
    cssClass: "advert",
    hideInMenu: true,
    pageLinks: [{
      index: 53,
      subIndex: 0
    }]
  }],
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    var windowWidth = payload.width;
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    console.log("Update Zoom: " + newZ + ", " + newX + ", " + newY + ", " + context.state.pageScale);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state) {
    return state.activePanel == "Contents";
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contentsEnabled;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoomEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {
      transform: "scale(" + getters.pageContainerZoomLevel * state.pageScale + ")"
    };
    if (state.zoomLevel !== 1) {
      styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";
    } else {
      styleObject.transformOrigin = "0px 0px";
    }
    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/mutations.js


var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }
  console.log("Toggle Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || 2;
  // console.log('update zoom', payload)
  console.log("Update Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  if (state.zoomLevel < 1) {
    state.zoomLevel = 1;
    console.log("Update Zoom2: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    isDoublePage: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("mousewheel", this.mouseWheelHandler);
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed) {
          // console.log("is actually panning")
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.wheelDelta > 0) {
      Publish.goToPreviousSection();
    } else {
      Publish.goToNextSection();
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      console.log("WORKING");
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-199016370-49',
  router: router
});

/* eslint-disable no-new */
window.Publish = new vue_esm["a" /* default */]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "Pg37":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QkI9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S4/L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U2l4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V6ic":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WN8W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zf2O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eJtY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i9d8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oPvi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pXbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tGyY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uDJ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.331ee786d6a85c142967.js